/* SADU Atelier 2.0 - bundle built 2026-09-09 19:08 */

/* ===== sa2-core.js ===== */
/* SADU Atelier 2.0 — core (loaded first). Shared utils, pointer state, module registry, boot. */
window.SA2 = window.SA2 || {};
(function () {
  var S = window.SA2;
  if (S.util) return;
  S.util = {
    reduce: matchMedia('(prefers-reduced-motion: reduce)').matches,
    isDesk: function () { return matchMedia('(min-width: 990px)').matches; },
    isTouch: matchMedia('(hover: none)').matches,
    dpr: Math.min(window.devicePixelRatio || 1, 1.5),
    clamp: function (v, a, b) { return Math.max(a, Math.min(b, v)); },
    lerp: function (a, b, t) { return a + (b - a) * t; },
    /* IntersectionObserver helper: cb(true|false). Returns unsubscribe. */
    onVisible: function (el, cb) {
      if (!('IntersectionObserver' in window)) { cb(true); return function () {}; }
      var io = new IntersectionObserver(function (es) { cb(es.some(function (e) { return e.isIntersecting; })); }, { threshold: 0.02 });
      io.observe(el); return function () { io.disconnect(); };
    },
    /* Section-wide event bus: SA2.util.emit('front', {...}) / SA2.util.on('front', fn) */
    emit: function (name, detail) { document.dispatchEvent(new CustomEvent('sa2:' + name, { detail: detail })); },
    on: function (name, fn) { document.addEventListener('sa2:' + name, fn); return function () { document.removeEventListener('sa2:' + name, fn); }; },
    /* Only after a real user gesture: Chrome logs an error for vibrate() before the first tap */
    haptic: function (ms) { try { if (S.interacted && navigator.vibrate) navigator.vibrate(ms || 8); } catch (e) {} },
    hexToRgb: function (hex) {
      var h = String(hex || '#caa86a').replace('#', '');
      if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
      var n = parseInt(h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    },
    /* Resize a canvas to the CSS size of `el` (or its own box) times dpr. Returns {w,h} in CSS px. */
    fitCanvas: function (canvas, el) {
      var r = (el || canvas).getBoundingClientRect(), d = S.util.dpr;
      var w = Math.max(1, Math.round(r.width)), h = Math.max(1, Math.round(r.height));
      if (canvas.width !== Math.round(w * d) || canvas.height !== Math.round(h * d)) { canvas.width = Math.round(w * d); canvas.height = Math.round(h * d); }
      return { w: w, h: h };
    },
    /* Cheap seeded PRNG (mulberry32) for deterministic generative art */
    prng: function (seed) { var a = seed >>> 0; return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; },
    hash: function (str) { var h = 2166136261; for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  };
  /* Shared pointer state, in CSS px relative to the section's top-left. active=false when the pointer left. */
  S.pointer = { x: -1e4, y: -1e4, px: -1e4, py: -1e4, active: false, down: false, t: 0 };
  /* Shared state written by modules (ring writes front index/tint; finder writes open) */
  S.state = { front: 0, tint: '#f4d6cc', finderOpen: false, visible: true };
  S.modules = {};
  S.register = function (name, init) { S.modules[name] = init; };
  /* Boot one section. Order matters: fx last so it can hook everything. */
  S.boot = function (section) {
    if (!section || section.__sa2) return section && section.__sa2;
    var apis = {};
    var rect = function () { return section.getBoundingClientRect(); };
    section.addEventListener('pointermove', function (e) {
      var r = rect(); S.pointer.px = S.pointer.x; S.pointer.py = S.pointer.y;
      S.pointer.x = e.clientX - r.left; S.pointer.y = e.clientY - r.top; S.pointer.active = true; S.pointer.t = performance.now();
    }, { passive: true });
    section.addEventListener('pointerdown', function () { S.pointer.down = true; S.interacted = true; }, { passive: true });
    window.addEventListener('touchend', function () { S.interacted = true; }, { passive: true, once: true });
    window.addEventListener('keydown', function () { S.interacted = true; }, { passive: true, once: true });
    window.addEventListener('pointerup', function () { S.pointer.down = false; }, { passive: true });
    window.addEventListener('pointercancel', function () { S.pointer.down = false; }, { passive: true });
    section.addEventListener('pointerleave', function () { S.pointer.active = false; S.pointer.x = S.pointer.y = -1e4; });
    S.util.onVisible(section, function (v) { S.state.visible = v; section.classList.toggle('is-inview', v); S.util.emit('visible', { visible: v }); });
    ['silk', 'notes', 'dust', 'ring', 'finder', 'fx'].forEach(function (name) {
      var m = S.modules[name]; if (!m) return;
      try { apis[name] = m(section, apis) || {}; } catch (err) { console.warn('[SA2] module failed:', name, err); }
    });
    section.__sa2 = apis;
    S.util.emit('ready', { section: section, apis: apis });
    return apis;
  };
  var start = function () { document.querySelectorAll('[data-sa2]').forEach(S.boot); };
  /* The modules register themselves later in the same bundle, so never boot synchronously here:
     wait for DOMContentLoaded, or (script already deferred past parsing) yield one macrotask so the
     rest of the bundle has executed and every SA2.register() call has landed. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else setTimeout(start, 0);
  /* Shopify theme editor: re-boot when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { var s = e.target && e.target.querySelector && e.target.querySelector('[data-sa2]'); if (s) S.boot(s); });
  /* Theme editor: tear the old instance down so its window/document listeners (and the shared event bus) do not outlive the DOM */
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target && e.target.querySelector && e.target.querySelector('[data-sa2]');
    var apis = s && s.__sa2; if (!apis) return;
    ['fx', 'finder', 'ring', 'dust', 'notes', 'silk'].forEach(function (name) { try { if (apis[name] && apis[name].destroy) apis[name].destroy(); } catch (err) {} });
    s.__sa2 = null;
  });
})();


/* ===== sa2-silk.js ===== */
/* SADU Atelier 2.0 — silk: WebGL "liquid silk" background on [data-sa2-silk].
   Domain-warped fbm in cream/rose/powder-blue/gold, time-of-day palette, pointer stir + wake,
   tap "drop" ripple, gold glints, tint bleed from the front ring panel. 2D fallback when no WebGL.
   Section settings (data-bg off|soft|full, data-bg-mobile static|lite|full, data-perf lite|full) pick the
   look and the phone cost: "soft" = faint vapour (colours half-way into the cream, slower, calmer stir,
   fewer glints); "static" = one frame, no loop; "lite" = 0.4× scale, 24 fps, 2-octave fbm. */
(function () {
  'use strict';
  if (!window.SA2 || typeof SA2.register !== 'function') return;
  var U = SA2.util;

  var CREAM = '#fbf9f7', GOLD = '#caa86a';
  var MODES = {
    morning:   { a: '#cfe1ec', b: '#d8e9d6', gold: 0.75 },   /* fresh blue / mint */
    afternoon: { a: '#f4d6cc', b: '#f7e6c9', gold: 1.0 },    /* rose / cream */
    evening:   { a: '#f5e4bf', b: '#f6dcd2', gold: 1.45 }    /* amber / warm rose, more gold */
  };
  var TRAIL_N = 6;

  var VERT = [
    'attribute vec2 aPos;',
    'varying vec2 vUv;',
    'void main(){ vUv = aPos * 0.5 + 0.5; gl_Position = vec4(aPos, 0.0, 1.0); }'
  ].join('\n');

  var FRAG = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform vec2 uTG;',               /* x = time (s), y = gold amount — packed to stay under the 16-vector GLES2 minimum */
    'uniform vec2 uRes;',
    'uniform vec4 uPointer;',          /* x, y (aspect space), signed strength, down */
    'uniform vec3 uTrail[' + TRAIL_N + '];', /* x, y, strength */
    'uniform vec4 uDrop;',             /* x, y, age 0..1, strength */
    'uniform vec3 uCream;',
    'uniform vec3 uColA;',
    'uniform vec3 uColB;',
    'uniform vec3 uGold;',
    'uniform vec3 uLook;',             /* x = sheen amount, y = stir/drop amplitude, z = glint density (soft: .5/.5/.4, full: 1/1/1) */
    'varying vec2 vUv;',
    /* Simplex 2D (Ashima / Stefan Gustavson, MIT) */
    'vec3 mod289(vec3 x){ return x - floor(x * (1.0 / 289.0)) * 289.0; }',
    'vec2 mod289(vec2 x){ return x - floor(x * (1.0 / 289.0)) * 289.0; }',
    'vec3 permute(vec3 x){ return mod289(((x * 34.0) + 1.0) * x); }',
    'float snoise(vec2 v){',
    '  const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);',
    '  vec2 i = floor(v + dot(v, C.yy));',
    '  vec2 x0 = v - i + dot(i, C.xx);',
    '  vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);',
    '  vec4 x12 = x0.xyxy + C.xxzz; x12.xy -= i1;',
    '  i = mod289(i);',
    '  vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));',
    '  vec3 m = max(0.5 - vec3(dot(x0, x0), dot(x12.xy, x12.xy), dot(x12.zw, x12.zw)), 0.0);',
    '  m = m * m; m = m * m;',
    '  vec3 x = 2.0 * fract(p * C.www) - 1.0;',
    '  vec3 h = abs(x) - 0.5;',
    '  vec3 ox = floor(x + 0.5);',
    '  vec3 a0 = x - ox;',
    '  m *= 1.79284291400159 - 0.85373472095314 * (a0 * a0 + h * h);',
    '  vec3 g; g.x = a0.x * x0.x + h.x * x0.y; g.yz = a0.yz * x12.xz + h.yz * x12.yw;',
    '  return 130.0 * dot(m, g);',
    '}',
    'float fbm(vec2 p){',
    '  float s = 0.0, a = 0.5;',
    '  for (int i = 0; i < OCT; i++) { s += a * snoise(p); p = p * 2.03 + vec2(1.7, 9.2); a *= 0.5; }',
    '  return s;',
    '}',
    /* soft vortex: rotates the space around c, strength falls off with a gaussian */
    'vec2 swirl(vec2 p, vec2 c, float str, float rad){',
    '  vec2 d = p - c; float a = str * exp(-dot(d, d) / rad);',
    '  float s = sin(a), co = cos(a);',
    '  return c + vec2(d.x * co - d.y * s, d.x * s + d.y * co);',
    '}',
    'float hash21(vec2 p){ p = fract(p * vec2(123.34, 456.21)); p += dot(p, p + 45.32); return fract(p.x * p.y); }',
    'void main(){',
    '  float asp = uRes.x / uRes.y;',
    '  vec2 uv = vUv;',
    '  vec2 p = (uv - 0.5) * vec2(asp, 1.0);',
    '  float t = uTG.x; float goldAmt = uTG.y;',
    /* pointer stir + its wake (trail of decaying vortices) */
    '  p = swirl(p, uPointer.xy, uPointer.z * 1.35 * uLook.y, 0.045 + 0.035 * uPointer.w);',
    '  for (int i = 0; i < ' + TRAIL_N + '; i++) { p = swirl(p, uTrail[i].xy, uTrail[i].z * 0.75 * uLook.y, 0.028); }',
    /* tap drop: an expanding ring wave, like a drop landing on perfume */
    '  { vec2 d = p - uDrop.xy; float r = length(d) + 1e-4; float ring = r - uDrop.z * 0.85;',
    '    float w = sin(ring * 34.0) * exp(-ring * ring * 70.0) * (1.0 - uDrop.z) * uDrop.w * uLook.y;',
    '    p += d / r * w * 0.035; }',
    /* domain-warped flow */
    '  vec2 s = p * 0.95;',
    '  vec2 q = vec2(fbm(s + vec2(t * 0.045, t * 0.02)), fbm(s + vec2(5.2, 1.3) - t * 0.035));',
    '  vec2 r = vec2(fbm(s + 1.3 * q + vec2(1.7, 9.2) + t * 0.03), fbm(s + 1.3 * q + vec2(8.3, 2.8) - t * 0.025));',
    '  float n = fbm(s + 1.1 * r) * 0.5 + 0.5;',
    '  float n2 = q.x * 0.5 + 0.5;',
    /* colour: stays light (avg luminance > 0.9) */
    '  vec3 col = uCream;',
    '  col = mix(col, uColA, smoothstep(0.2, 0.85, n) * 0.58);',
    '  col = mix(col, uColB, smoothstep(0.3, 0.9, r.y * 0.5 + 0.5) * 0.4);',
    /* silk sheen: a soft highlight along the fold */
    '  float sheen = pow(1.0 - clamp(abs(n - 0.52) * 3.0, 0.0, 1.0), 3.0);',
    '  col = mix(col, vec3(1.0), sheen * 0.22 * uLook.x);',
    /* faint gold veins */
    '  float vein = smoothstep(0.5, 0.9, n2 * 0.6 + r.x * 0.4 + 0.2);',
    '  col = mix(col, uGold, vein * 0.085 * goldAmt);',
    /* gold glint specks, twinkling, carried by the flow */
    '  vec2 gp = p * 26.0 + r * 0.6;',
    '  vec2 gi = floor(gp); vec2 gf = fract(gp) - 0.5;',
    '  float h = hash21(gi);',
    '  float tw = 0.5 + 0.5 * sin(t * 2.2 + h * 60.0);',
    '  vec2 off = (vec2(h, fract(h * 7.31)) - 0.5) * 0.4;',
    '  float spec = step(1.0 - 0.014 * goldAmt * uLook.z, h) * (1.0 - smoothstep(0.0, 0.2, length(gf + off))) * tw * tw;',
    '  col = mix(col, mix(uGold, vec3(1.0), 0.5), spec * 0.75);',
    /* wet glow under the finger */
    '  vec2 pd = p - uPointer.xy;',
    '  float pg = exp(-dot(pd, pd) * 28.0) * abs(uPointer.z) * uLook.y;',
    '  col = mix(col, uColA, pg * 0.35) + pg * 0.06;',
    /* fade top/bottom edges into the page cream */
    '  float e = smoothstep(0.8, 1.0, abs(uv.y * 2.0 - 1.0));',
    '  col = mix(col, uCream, e * 0.8);',
    '  gl_FragColor = vec4(col, 1.0);',
    '}'
  ].join('\n');

  function modeForHour(h) { return h >= 5 && h < 12 ? 'morning' : (h >= 12 && h < 18 ? 'afternoon' : 'evening'); }
  function rgb01(hex) { var c = U.hexToRgb(hex); return [c[0] / 255, c[1] / 255, c[2] / 255]; }
  function css(c, a) { return 'rgba(' + Math.round(c[0] * 255) + ',' + Math.round(c[1] * 255) + ',' + Math.round(c[2] * 255) + ',' + a + ')'; }
  function lerp3(o, a, b, k) { o[0] += (a[0] - o[0]) * k; o[1] += (a[1] - o[1]) * k; o[2] += (a[2] - o[2]) * k; return o; }
  function mix3(o, a, b, k) { o[0] = a[0] + (b[0] - a[0]) * k; o[1] = a[1] + (b[1] - a[1]) * k; o[2] = a[2] + (b[2] - a[2]) * k; return o; }
  /* frame-rate independent easing factor for a time constant tau (ms) */
  function ease(dt, tau) { return 1 - Math.exp(-dt / tau); }

  /* ---------- WebGL renderer ---------- */
  /* oct = fbm octaves (3 today; 2 on the phone "lite" mode) — baked in as a #define so the loop unrolls */
  function makeGL(gl, oct) {
    function compile(type, src) {
      var sh = gl.createShader(type); gl.shaderSource(sh, src); gl.compileShader(sh);
      if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) { var log = gl.getShaderInfoLog(sh); gl.deleteShader(sh); throw new Error('silk shader: ' + log); }
      return sh;
    }
    var vs = compile(gl.VERTEX_SHADER, VERT);
    var fs = compile(gl.FRAGMENT_SHADER, '#define OCT ' + (oct === 2 ? 2 : 3) + '\n' + FRAG);
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { var l = gl.getProgramInfoLog(prog); gl.deleteProgram(prog); throw new Error('silk link: ' + l); }
    gl.deleteShader(vs); gl.deleteShader(fs);
    gl.useProgram(prog);
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var aPos = gl.getAttribLocation(prog, 'aPos');
    gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);
    gl.disable(gl.DEPTH_TEST); gl.disable(gl.BLEND);
    var L = {};
    ['uTG', 'uRes', 'uPointer', 'uDrop', 'uCream', 'uColA', 'uColB', 'uGold', 'uLook'].forEach(function (n) { L[n] = gl.getUniformLocation(prog, n); });
    L.uTrail = gl.getUniformLocation(prog, 'uTrail') || gl.getUniformLocation(prog, 'uTrail[0]');
    return {
      scaleMul: 1,
      resize: function (pw, ph) { gl.viewport(0, 0, pw, ph); },
      frame: function (t, st) {
        gl.uniform2f(L.uTG, t, st.g);
        gl.uniform2f(L.uRes, st.pw, st.ph);
        gl.uniform4f(L.uPointer, st.px, st.py, st.ps, st.pdown);
        gl.uniform3fv(L.uTrail, st.trail);
        gl.uniform4f(L.uDrop, st.dx, st.dy, st.dage, st.ds);
        gl.uniform3f(L.uCream, st.cream[0], st.cream[1], st.cream[2]);
        gl.uniform3f(L.uColA, st.a[0], st.a[1], st.a[2]);
        gl.uniform3f(L.uColB, st.b[0], st.b[1], st.b[2]);
        gl.uniform3f(L.uGold, st.gold[0], st.gold[1], st.gold[2]);
        gl.uniform3f(L.uLook, st.look[0], st.look[1], st.look[2]);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      },
      destroy: function () {
        try { gl.deleteBuffer(buf); gl.deleteProgram(prog); } catch (e) {}
        try { var ext = gl.getExtension('WEBGL_lose_context'); if (ext) ext.loseContext(); } catch (e2) {}
      }
    };
  }

  /* ---------- 2D fallback: drifting radial gradients ---------- */
  function make2D(ctx) {
    var W = 1, H = 1;
    var blobs = [
      { c: 'a', r: 0.62, f: 0.11, ph: 0.3, ax: 0.36, ay: 0.3 },
      { c: 'b', r: 0.55, f: 0.09, ph: 2.1, ax: 0.4, ay: 0.34 },
      { c: 'a', r: 0.45, f: 0.13, ph: 4.0, ax: 0.32, ay: 0.38 },
      { c: 'gold', r: 0.3, f: 0.07, ph: 1.2, ax: 0.42, ay: 0.4 }
    ];
    return {
      scaleMul: 0.5,
      resize: function (pw, ph) { W = pw; H = ph; },
      frame: function (t, st) {
        ctx.globalAlpha = 1;
        ctx.fillStyle = css(st.cream, 1); ctx.fillRect(0, 0, W, H);
        var m = Math.max(W, H);
        for (var i = 0; i < blobs.length; i++) {
          var b = blobs[i];
          var x = W * (0.5 + b.ax * Math.sin(t * b.f + b.ph)), y = H * (0.5 + b.ay * Math.cos(t * b.f * 0.83 + b.ph * 1.7));
          var col = b.c === 'gold' ? st.gold : st[b.c], alpha = b.c === 'gold' ? 0.22 * st.g : 0.75;
          var g = ctx.createRadialGradient(x, y, 0, x, y, m * b.r);
          g.addColorStop(0, css(col, alpha)); g.addColorStop(1, css(col, 0));
          ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
        }
        if (Math.abs(st.ps) > 0.02) {
          var px = (st.px / (W / H) + 0.5) * W, py = (0.5 - st.py) * H, rr = m * 0.22;
          var pg = ctx.createRadialGradient(px, py, 0, px, py, rr);
          pg.addColorStop(0, css(st.a, 0.7 * Math.abs(st.ps) * st.look[1])); pg.addColorStop(1, css(st.a, 0));
          ctx.fillStyle = pg; ctx.fillRect(0, 0, W, H);
        }
      },
      destroy: function () {}
    };
  }

  SA2.register('silk', function (section) {
    var noop = function () {};
    var api = { pause: noop, resume: noop, resize: noop, destroy: noop, setPalette: noop, drop: noop, mode: function () { return 'auto'; } };
    var canvas = section && section.querySelector ? section.querySelector('[data-sa2-silk]') : null;
    if (!canvas || !canvas.getContext) return api;

    var mobile = U.isTouch || !U.isDesk();
    var reduce = !!U.reduce;

    /* section settings (rendered by Liquid on <section data-sa2>; every one has a default) */
    function setting(name, def, allowed) {
      var v = null; try { v = section.getAttribute(name); } catch (e) { v = null; }
      v = v == null ? '' : String(v).trim().toLowerCase();
      return allowed.indexOf(v) >= 0 ? v : def;
    }
    var bg = setting('data-bg', 'soft', ['off', 'soft', 'full', 'notes']);
    if (bg === 'off' || bg === 'notes') return api;   /* 'notes' = the constellation module owns the background */   /* base CSS hides the canvas: no GL context, no listeners, no loop */
    var bgMobile = setting('data-bg-mobile', 'static', ['static', 'lite', 'full']);
    var perfLite = setting('data-perf', 'lite', ['lite', 'full']) === 'lite';
    /* data-bg-opacity is applied by base CSS as canvas opacity — never re-applied here */
    var soft = bg === 'soft';
    var isStatic = reduce || (mobile && bgMobile === 'static');   /* one frame at boot / resize / palette / tint, never a rAF loop */
    var lite = mobile && !isStatic && bgMobile === 'lite';
    var oct = lite ? 2 : 3;                    /* fbm octaves */
    /* look: soft = faint living vapour (colours half-way into the cream, 0.6× flow, half stir/drop, 0.4× glints) */
    var colK = soft ? 0.5 : 1;                 /* colour deviation from cream */
    var timeScale = soft ? 0.6 : 1;
    var look = soft ? [0.5, 0.5, 0.4] : [1, 1, 1];   /* uLook: sheen, stir/drop amplitude, glint density */

    var baseScale = (U.dpr || 1) * (mobile ? 0.75 : 1) * (lite ? 0.4 : 1);
    var budget = mobile ? 520000 : 1250000;   /* max backing-store pixels; silk is blurry, upscaling is invisible */
    if (lite) budget = Math.min(budget, 120000);
    if (perfLite && mobile && !isStatic) budget = Math.min(budget, 150000);   /* global low-power switch */
    var quality = 1;                          /* adaptive, only ever lowers */

    /* renderer selection */
    var renderer = null, gl = null, is2D = false;
    try {
      var opts = { alpha: false, antialias: false, depth: false, stencil: false, premultipliedAlpha: true, powerPreference: 'low-power', preserveDrawingBuffer: false, failIfMajorPerformanceCaveat: false };
      gl = canvas.getContext('webgl', opts) || canvas.getContext('experimental-webgl', opts);
      if (gl) renderer = makeGL(gl, oct);
    } catch (e) { renderer = null; }
    if (!renderer) {
      if (gl) {
        /* a canvas that already owns a WebGL context can never hand out a 2D one (and with alpha:false it
           composites as opaque BLACK behind the text) — release it and swap in a fresh canvas element */
        try { var lose = gl.getExtension('WEBGL_lose_context'); if (lose) lose.loseContext(); } catch (e4) {}
        try { var fresh = canvas.cloneNode(false); if (canvas.parentNode) { canvas.parentNode.replaceChild(fresh, canvas); canvas = fresh; } } catch (e5) {}
        gl = null;
      }
      try { var ctx = canvas.getContext('2d'); if (ctx) { renderer = make2D(ctx); is2D = true; } } catch (e2) { renderer = null; }
    }
    if (!renderer) { try { canvas.style.visibility = 'hidden'; } catch (e6) {} return api; }

    try { canvas.style.width = '100%'; canvas.style.height = '100%'; canvas.style.display = 'block'; } catch (e3) {}

    /* geometry */
    var W = 0, H = 0, PW = 0, PH = 0, asp = 1;
    /* loop state */
    var paused = false, visible = SA2.state ? SA2.state.visible !== false : true, destroyed = false, lost = false, raf = 0;
    var fPaused = !!(SA2.state && SA2.state.finderOpen);   /* finder open: the overlay backdrop-blurs us every frame, so hold the last frame */
    var t0 = performance.now(), last = t0, ema = 16, frames = 0, nextCheck = 120, minQuality = mobile ? 0.5 : 0.45, frameGap = is2D ? 33 : 0, lastDraw = 0;
    /* phone throttle: "lite" and the global low-power switch both cap the loop at ~24 fps */
    if (lite || (perfLite && mobile && !isStatic)) frameGap = Math.max(frameGap, 1000 / 24);
    var hourFrames = 0;

    /* pointer / stir state (aspect space: x in [-asp/2, asp/2], y in [-0.5, 0.5]) */
    var P = SA2.pointer || { x: -1e4, y: -1e4, px: -1e4, py: -1e4, active: false, down: false };
    var touching = false;
    var st = {
      pw: 1, ph: 1, px: 0, py: 0, ps: 0, pdown: 0,
      trail: new Float32Array(TRAIL_N * 3), dx: 0, dy: 0, dage: 1, ds: 0,
      cream: rgb01(CREAM), gold: rgb01(GOLD), a: [0, 0, 0], b: [0, 0, 0], g: 1, look: look
    };
    /* soft look: pull a colour half-way back into the cream (in place). Identity when colK = 1. */
    function soften(v) { if (colK !== 1) { var c = st.cream; v[0] = c[0] + (v[0] - c[0]) * colK; v[1] = c[1] + (v[1] - c[1]) * colK; v[2] = c[2] + (v[2] - c[2]) * colK; } return v; }
    soften(st.gold);
    var dir = 1, sTarget = 0, trailAt = 0, trailIdx = 0, lastTx = 9, lastTy = 9, dropT = -1e9;

    /* palette */
    var modeSet = 'auto', modeNow = modeForHour(new Date().getHours());
    var curA = rgb01(MODES[modeNow].a), curB = rgb01(MODES[modeNow].b), curG = MODES[modeNow].gold;
    var tgtA = curA.slice(), tgtB = curB.slice(), tgtG = curG;
    var tint = curA.slice(), tintTgt = curA.slice(), tintAmt = 0, tintAmtTgt = 0;

    function applyMode(m, snap) {
      var def = MODES[m] || MODES.afternoon;
      tgtA = rgb01(def.a); tgtB = rgb01(def.b); tgtG = def.gold;
      if (snap) { curA = tgtA.slice(); curB = tgtB.slice(); curG = tgtG; }
    }

    function toAspect(x, y) { return [(x / W - 0.5) * asp, 0.5 - y / H]; }

    function update(dt, now) {
      /* pointer: smoothed position + strength, direction sign gives the stir its handedness */
      var finder = !!(SA2.state && SA2.state.finderOpen);
      var active = !finder && !!P.active && P.x > -1e3 && (!U.isTouch || touching);
      if (active) {
        var a = toAspect(P.x, P.y);
        var kp = ease(dt, 85);
        st.px += (a[0] - st.px) * kp; st.py += (a[1] - st.py) * kp;
        var vx = P.x - P.px;
        if (vx > 0.6) dir = 1; else if (vx < -0.6) dir = -1;
        sTarget = P.down ? 1.55 : 1;
      } else sTarget = 0;
      var ks = ease(dt, sTarget > 0 ? 140 : 520);
      var s = Math.abs(st.ps); s += (sTarget - s) * ks;
      st.ps = s * dir;
      st.pdown = P.down && active ? 1 : 0;
      /* wake: drop a vortex behind the pointer every ~60ms while it moves; each decays (half-life 420ms) */
      var tr = st.trail, decay = Math.pow(0.5, dt / 420);
      for (var i = 2; i < tr.length; i += 3) tr[i] *= decay;
      if (s > 0.15 && now - trailAt > 60) {
        var mx = st.px - lastTx, my = st.py - lastTy;
        if (mx * mx + my * my > 0.00012) {
          var j = trailIdx * 3; tr[j] = st.px; tr[j + 1] = st.py; tr[j + 2] = Math.min(1, s) * dir;
          trailIdx = (trailIdx + 1) % TRAIL_N; trailAt = now; lastTx = st.px; lastTy = st.py;
        }
      }
      /* drop ring */
      var age = (now - dropT) / 1400;
      st.dage = age < 1 ? age : 1; st.ds = age < 1 ? 1 : 0;
      /* palette drift + tint bleed from the front ring panel */
      var kc = ease(dt, 900);
      lerp3(curA, tgtA, null, kc); lerp3(curB, tgtB, null, kc); curG += (tgtG - curG) * kc;
      lerp3(tint, tintTgt, null, ease(dt, 1400)); tintAmt += (tintAmtTgt - tintAmt) * ease(dt, 1400);
      mix3(st.a, curA, tint, tintAmt); st.b[0] = curB[0]; st.b[1] = curB[1]; st.b[2] = curB[2]; st.g = curG;
      soften(st.a); soften(st.b);
      /* auto time-of-day: re-check about every 10s of running time */
      if (modeSet === 'auto' && ++hourFrames > 600) {
        hourFrames = 0; var m = modeForHour(new Date().getHours());
        if (m !== modeNow) { modeNow = m; applyMode(m, false); }
      }
    }

    /* t in seconds; the soft look flows at 0.6× (also slows the 2D fallback drift) */
    function draw(t) { if (destroyed) return; try { renderer.frame(t * timeScale, st); } catch (e) { /* never throw from the loop */ } }

    function renderStatic() {
      /* reduced motion / phone "static": one calm frame, palette snapped, no pointer */
      curA = tgtA.slice(); curB = tgtB.slice(); curG = tgtG; tint = tintTgt.slice(); tintAmt = tintAmtTgt;
      mix3(st.a, curA, tint, tintAmt); st.b = curB.slice(); st.g = curG;
      soften(st.a); soften(st.b);
      st.ps = 0; st.pdown = 0; st.ds = 0;
      draw(37.0);
    }

    function perf(dt) {
      ema += (dt - ema) * 0.05;
      if (++frames < nextCheck) return;
      nextCheck = frames + 90;
      if (ema > 21 && quality > minQuality) { quality = Math.max(minQuality, quality * 0.8); resize(true); }
    }

    function step(now) {
      raf = 0;
      if (destroyed || paused || fPaused || !visible || lost || document.hidden) return;
      /* rdt = rAF cadence (the perf signal, sampled on skipped frames too); dt = time since the last DRAWN
         frame, so easing stays frame-rate independent when the loop is throttled to 24 fps */
      var rdt = Math.min(64, now - last); last = now;
      if (frameGap && now - lastDraw < frameGap) { if (!is2D) perf(rdt); raf = requestAnimationFrame(step); return; }
      var dt = Math.min(64, now - lastDraw); lastDraw = now;
      update(dt, now);
      draw((now - t0) / 1000);
      if (!is2D) perf(rdt);
      raf = requestAnimationFrame(step);
    }

    function kick() {
      if (destroyed || raf || paused || fPaused || !visible || lost || isStatic) return;
      last = performance.now(); lastDraw = last - frameGap;   /* first frame draws right away */
      raf = requestAnimationFrame(step);
    }

    function resize(force) {
      if (destroyed) return;
      var r = section.getBoundingClientRect();
      var w = Math.max(1, Math.round(r.width)), h = Math.max(1, Math.round(r.height));
      var sc = baseScale * quality * renderer.scaleMul;
      var px = w * h * sc * sc; if (px > budget) sc *= Math.sqrt(budget / px);
      var pw = Math.max(1, Math.round(w * sc)), ph = Math.max(1, Math.round(h * sc));
      if (!force && w === W && h === H && pw === PW && ph === PH) return;
      W = w; H = h; PW = pw; PH = ph; asp = w / h; st.pw = pw; st.ph = ph;
      canvas.width = pw; canvas.height = ph;
      try { renderer.resize(pw, ph); } catch (e) {}
      /* resizing clears the buffer (opaque black with alpha:false) — repaint now instead of waiting for
         the next rAF, which may never come while paused / off-screen / reduced-motion */
      if (isStatic) renderStatic(); else if (!lost) draw((performance.now() - t0) / 1000);
    }

    /* ---------- listeners ---------- */
    var offs = [];
    function listen(target, ev, fn, o) { target.addEventListener(ev, fn, o); offs.push(function () { target.removeEventListener(ev, fn, o); }); }

    var rsT = 0;
    function onResize() { clearTimeout(rsT); rsT = setTimeout(function () { resize(false); }, 120); }
    listen(window, 'resize', onResize, { passive: true });
    listen(window, 'orientationchange', onResize, { passive: true });
    var ro = null;
    try { if ('ResizeObserver' in window) { ro = new ResizeObserver(onResize); ro.observe(section); } } catch (e) { ro = null; }

    function dropAt(x, y) {
      if (isStatic || !W) return;
      var a = toAspect(x, y); st.dx = a[0]; st.dy = a[1]; dropT = performance.now();
      /* pointer was idle (touch tap): start the stir under the finger, not lerping in from afar */
      if (Math.abs(st.ps) < 0.1) { st.px = a[0]; st.py = a[1]; lastTx = a[0]; lastTy = a[1]; }
    }
    if (!isStatic) {   /* static never stirs or drops — no pointer listeners at all */
      listen(section, 'pointerdown', function (e) {
        if (SA2.state && SA2.state.finderOpen) return;   /* taps on the finder dialog must not stir the background */
        touching = true;
        try { var r = section.getBoundingClientRect(); dropAt(e.clientX - r.left, e.clientY - r.top); } catch (err) {}
      }, { passive: true });
      var release = function () { touching = false; };
      listen(window, 'pointerup', release, { passive: true });
      listen(window, 'pointercancel', release, { passive: true });
    }

    listen(document, 'visibilitychange', function () { if (!document.hidden) kick(); });
    offs.push(U.onVisible(section, function (v) { visible = v; if (v) kick(); }));

    /* tint bleed: the silk slowly remembers the colour of the portal in front */
    offs.push(U.on('front', function (e) {
      var d = e && e.detail; if (!d || !d.tint) return;
      try { tintTgt = rgb01(d.tint); tintAmtTgt = 0.5; if (isStatic) renderStatic(); } catch (err) {}
    }));
    /* finder open/close: same gate as dust/ring/fx — no GPU work under the modal */
    offs.push(U.on('finder', function (e) {
      fPaused = !!(e && e.detail && e.detail.open);
      if (fPaused) { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
      else kick();
    }));

    if (gl) {
      listen(canvas, 'webglcontextlost', function (e) { e.preventDefault(); lost = true; if (raf) { cancelAnimationFrame(raf); raf = 0; } });
      listen(canvas, 'webglcontextrestored', function () {
        try { renderer = makeGL(gl, oct); lost = false; resize(true); kick(); } catch (e) { lost = true; }
      });
    }

    /* ---------- API ---------- */
    api.pause = function () { paused = true; if (raf) { cancelAnimationFrame(raf); raf = 0; } };
    api.resume = function () { paused = false; kick(); };
    api.resize = function () { resize(true); };
    api.setPalette = function (mode) {
      var m = String(mode || 'auto').toLowerCase();
      if (m === 'night') m = 'evening';
      if (m !== 'auto' && !MODES[m]) m = 'auto';
      modeSet = m;
      modeNow = m === 'auto' ? modeForHour(new Date().getHours()) : m;
      applyMode(modeNow, false);
      if (isStatic) renderStatic();
    };
    api.mode = function () { return modeNow; };
    api.drop = function (x, y) { if (typeof x === 'number' && typeof y === 'number') dropAt(x, y); else dropAt(W / 2, H / 2); };
    api.destroy = function () {
      destroyed = true;
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      clearTimeout(rsT);
      offs.forEach(function (f) { try { f(); } catch (e) {} }); offs = [];
      try { if (ro) ro.disconnect(); } catch (e) {}
      try { renderer.destroy(); } catch (e2) {}
    };

    /* ---------- go ---------- */
    /* seed st.a / st.b / st.g from the palette BEFORE the first paint (they start as black; a page
       opened in a background tab would otherwise keep that dark first frame until it gets focus) */
    try { update(0, performance.now()); } catch (e0) {}
    try { resize(true); } catch (e) {}
    /* resize(true) already painted the static frame synchronously; only repaint if it bailed before sizing */
    if (isStatic) { if (!W) { try { renderStatic(); } catch (e) {} } }
    else kick();
    return api;
  });
})();


/* ===== sa2-notes.js ===== */
/* SADU Atelier 2.0 — notes: the version-1.0 "olfactive constellation" as a background (data-bg="notes").
   Fragrance-note names float slowly, link with gold hairlines when close, twinkle, and drift toward the
   pointer (desktop) or the finger while it is down (phones). 2D canvas, O(n²) with n ≤ 28: very cheap. */
(function () {
  var S = window.SA2; if (!S || !S.register) return;
  S.register('notes', function (section) {
    var NOOP = { pause: function () {}, resume: function () {}, resize: function () {}, destroy: function () {} };
    var mode = String(section.dataset.bg || 'notes').toLowerCase();
    var canvas = section.querySelector('[data-sa2-notes]');
    if (mode !== 'notes' || !canvas) return NOOP;
    var ctx = null; try { ctx = canvas.getContext('2d'); } catch (e) {}
    if (!ctx) return NOOP;
    var U = S.util, reduce = U.reduce;
    var phone = U.isTouch || !U.isDesk();
    var perfLite = String(section.dataset.perf || 'lite').toLowerCase() === 'lite' && phone;
    var isStatic = reduce;
    var fps = phone ? 30 : 60, gap = 1000 / fps;
    var NOTES = ['Oud', 'Rose', 'Vanilla', 'Saffron', 'Bergamot', 'Amber', 'Iris', 'Musk', 'Cedar', 'Jasmine', 'Tonka', 'Incense', 'Neroli', 'Pink Pepper', 'Sandalwood', 'Fig', 'Leather', 'Cardamom', 'Tuberose', 'Vetiver', 'Ambergris', 'Praline', 'Sea Salt', 'Violet', 'Patchouli', 'Lavender', 'Honey', 'Ginger'];
    var count = phone ? (perfLite ? 12 : 14) : 28;
    var acc = U.hexToRgb(section.dataset.accent || '#caa86a').join(',');
    var W = 0, H = 0, head = null, stars = [], raf = 0, alive = true, running = false;
    var visible = S.state.visible !== false, finderOpen = !!S.state.finderOpen, last = 0;
    var rnd = U.prng(U.hash(section.id || 'sa2-notes'));

    function seed() {
      stars = NOTES.slice(0, count).map(function (n) {
        return { n: n, x: .04 + rnd() * .92, y: .05 + rnd() * .9, vx: (rnd() - .5) * .00025, vy: (rnd() - .5) * .00025, s: 9 + rnd() * 4, ph: rnd() * 6.28 };
      });
    }
    function layout() {
      var r = U.fitCanvas(canvas, section); W = r.w; H = r.h;
      ctx.setTransform(U.dpr, 0, 0, U.dpr, 0, 0);
      head = null;
      var h = section.querySelector('[data-sa2-head]');
      if (h && H > 0) {
        var hr = h.getBoundingClientRect(), sr = section.getBoundingClientRect();
        head = { l: hr.left - sr.left, t: hr.top - sr.top, r: hr.right - sr.left, b: hr.bottom - sr.top };
        /* normalised keep-out band (headline + subtitle): stars inside it are relocated to random rows
           above or below, so they never pile up on one line */
        var bt = Math.max(0, (head.t - 18) / H), bb = Math.min(1, (head.b + 18) / H);
        head.bt = bt; head.bb = bb;
        for (var i = 0; i < stars.length; i++) {
          var s = stars[i];
          if (s.y > bt && s.y < bb) {
            var below = (1 - bb) > (bt - .05) || rnd() < .7;   /* most of the free space is below the head */
            s.y = below ? bb + .01 + rnd() * Math.max(.02, .9 - bb) : .05 + rnd() * Math.max(.02, bt - .06);
          }
        }
      }
    }
    function draw(t) {
      ctx.clearRect(0, 0, W, H);
      var p = S.pointer, px = p.active ? p.x : -1e4, py = p.active ? p.y : -1e4;
      if (phone && !p.down) { px = py = -1e4; }
      var pts = new Array(stars.length), i, j;
      for (i = 0; i < stars.length; i++) {
        var s = stars[i];
        if (!isStatic) {
          s.x += s.vx; s.y += s.vy;
          if (s.x < .03 || s.x > .97) s.vx *= -1;
          if (s.y < .04 || s.y > .96) s.vy *= -1;
          /* the headline band is a wall: a star drifting into it bounces back out */
          if (head && s.y > head.bt && s.y < head.bb) { s.vy *= -1; s.y += s.vy * 3; }
        }
        var x = s.x * W, y = s.y * H;
        var dx = px - x, dy = py - y, d = Math.hypot(dx, dy);
        if (d < 220) { var k = .12 * (1 - d / 220); x += dx * k; y += dy * k; }
        pts[i] = { x: x, y: y, s: s };
      }
      ctx.lineWidth = .7;
      for (i = 0; i < pts.length; i++) for (j = i + 1; j < pts.length; j++) {
        var a = pts[i], b = pts[j], dd = Math.hypot(a.x - b.x, a.y - b.y);
        if (dd < 170) { ctx.strokeStyle = 'rgba(' + acc + ',' + ((1 - dd / 170) * .35).toFixed(3) + ')'; ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke(); }
      }
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      for (i = 0; i < pts.length; i++) {
        var q = pts[i], tw = isStatic ? .6 : .5 + .5 * Math.sin(t / 900 + q.s.ph);
        ctx.fillStyle = 'rgba(' + acc + ',' + (.55 + .45 * tw).toFixed(3) + ')'; ctx.beginPath(); ctx.arc(q.x, q.y, 1.6 + tw, 0, 6.2832); ctx.fill();
        ctx.fillStyle = 'rgba(18,18,18,' + (.22 + .25 * tw).toFixed(3) + ')'; ctx.font = q.s.s + 'px Jost, sans-serif'; ctx.fillText(q.s.n.toUpperCase(), q.x, q.y - 12);
      }
    }
    function frame(t) { raf = 0; if (!alive || !running) return; if (t - last >= gap) { last = t; draw(t); } raf = requestAnimationFrame(frame); }
    function start() { if (!alive || isStatic || running || !visible || finderOpen) return; running = true; last = 0; if (!raf) raf = requestAnimationFrame(frame); }
    function stop() { running = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    function paintStatic() { if (alive) { try { draw(37000); } catch (e) {} } }

    seed(); layout();
    if (isStatic) paintStatic(); else start();

    var offVis = U.on('visible', function (e) { visible = !!(e.detail && e.detail.visible); if (visible) start(); else stop(); });
    var offFinder = U.on('finder', function (e) { finderOpen = !!(e.detail && e.detail.open); if (finderOpen) stop(); else start(); });
    var rt = 0;
    function onResize() { clearTimeout(rt); rt = setTimeout(function () { if (!alive) return; layout(); if (isStatic) paintStatic(); }, 120); }
    window.addEventListener('resize', onResize, { passive: true });
    var ro = null; try { if ('ResizeObserver' in window) { ro = new ResizeObserver(onResize); ro.observe(section); } } catch (e) {}
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (alive && isStatic) paintStatic(); }); } catch (e) {}

    return {
      pause: stop,
      resume: start,
      resize: function () { layout(); if (isStatic) paintStatic(); },
      destroy: function () { alive = false; stop(); offVis(); offFinder(); window.removeEventListener('resize', onResize); if (ro) ro.disconnect(); clearTimeout(rt); try { ctx.clearRect(0, 0, W, H); } catch (e) {} }
    };
  });
})();


/* ===== sa2-dust.js ===== */
/* SADU Atelier 2.0 — dust: "scent dust" particle theatre.
   Gold/rose motes morph bottle → SADU → halo → vapour behind the headline.
   Signature extras: luminous "powder wake" behind the finger/mouse, an "exhale" when the ring snaps
   (dust breathes out in the new panel's tint), and gravity-tilt settling on phones.
   Section settings (read once at init): data-dust off|light|full, data-perf lite|full. */
(function () {
  if (!window.SA2 || typeof SA2.register !== 'function') return;

  SA2.register('dust', function (section) {
    var U = SA2.util, P = SA2.pointer, ST = SA2.state;
    var noop = function () {};
    var api = { pause: noop, resume: noop, resize: noop, destroy: noop, morphTo: noop, shape: function () { return 'off'; } };

    /* ---------- section settings (Liquid data attributes, all with defaults) ---------- */
    var attr = function (name, def) { var v = section.getAttribute(name); return v ? String(v).toLowerCase().trim() : def; };
    var mode = attr('data-dust', 'light');                                   /* off | light | full */
    if (mode === 'off') return api;                                          /* base CSS hides the canvas; no listeners, no loop */
    var light = mode !== 'full';                                             /* anything not "full" is treated as light */
    var phone = !!U.isTouch || !U.isDesk();
    if (phone && attr('data-dust-mobile', '0') !== '1') { var dc = section.querySelector('[data-sa2-dust]'); if (dc) dc.style.display = 'none'; return api; }   /* particles off on phones unless the merchant opts in */
    var lite = attr('data-perf', 'lite') === 'lite' && phone;                /* global low-power switch (phones only) */

    var canvas = section.querySelector('[data-sa2-dust]');
    var head = section.querySelector('[data-sa2-head]');
    if (!canvas || !canvas.getContext) return api;
    var ctx = null;
    try { ctx = canvas.getContext('2d', { alpha: true }); } catch (e) { ctx = null; }
    if (!ctx) return api;

    /* ---------- config ---------- */
    var touch = !!U.isTouch, reduce = !!U.reduce;
    var desk = U.isDesk() && !touch;
    var N = light ? (desk ? 1300 : 520) : (desk ? 2400 : 1100);
    var dpr = touch ? Math.min(U.dpr || 1, 1.25) : (U.dpr || 1);
    var ORDER = ['bottle', 'sadu', 'ring', 'vapour'];
    /* light: longer dwell (~9s) so the theatre reads as calmer and morphs cost less often */
    var HOLD = light ? { bottle: 9, sadu: 9, ring: 8.4, vapour: 7 } : { bottle: 7, sadu: 7, ring: 6.5, vapour: 5.5 };
    /* light: motes sit further back behind the headline */
    var ALPHA = light ? 0.78 : 1;
    /* hot-glow sprites (wake / exhale): off on phones in light mode and whenever perf is lite */
    var glow = !lite && !(light && phone);
    /* perf lite on a phone: ~30fps (skip every other rAF), no tilt listener, pause while the ring is grabbed */
    var throttle = lite, grabbing = false, mo = null;
    var MORPH_DUR = 1.1, MORPH_STAGGER = 0.5;          /* 1.1 + 0.5 = 1.6s total morph */
    var REPEL = 110, REPEL_DOWN = 150;
    var PI = Math.PI, TAU = PI * 2;
    var GOLD = [202, 168, 106], DEEP = [138, 109, 59], ROSE = [222, 160, 142];
    var rnd = U.prng(U.hash('sadu-dust'));

    /* ---------- particle store (typed arrays, no per-frame allocation) ---------- */
    var X = new Float32Array(N), Y = new Float32Array(N), VX = new Float32Array(N), VY = new Float32Array(N);
    var TX = new Float32Array(N), TY = new Float32Array(N), OX = new Float32Array(N), OY = new Float32Array(N);
    var PH = new Float32Array(N), SZ = new Float32Array(N), AL = new Float32Array(N);
    var DL = new Float32Array(N), CURL = new Float32Array(N), HEAT = new Float32Array(N);
    /* colour buckets (index ranges): 0 gold, 1 deep gold, 2 rose → bleeds toward the front panel tint */
    var B1 = Math.floor(N * 0.52), B2 = Math.floor(N * 0.74);
    var col = ['rgb(202,168,106)', 'rgb(138,109,59)', 'rgb(222,160,142)'];

    /* ---------- state ---------- */
    var w = 1, h = 1, cx = 0, cy = 0, size = 300;
    var shapes = {}, shape = 'bottle', free = false, order = 0;
    var t = 0, last = 0, hold = 0, morphT = 9, raf = 0, running = false;
    var paused = false, visible = false, destroyed = false, resizeQueued = 0;
    /* finder gate: driven by the sa2:finder event (seeded from state) so we never depend on whether
       the finder writes SA2.state.finderOpen before or after it emits */
    var fOpen = !!ST.finderOpen, builtSize = 0, forceBuild = false;
    var pulse = 0, tiltX = 0, tiltY = 0, tiltGX = 0, tiltGY = 0;
    var lpx = -1e4, lpy = -1e4, pspd = 0;
    var tintCur = ROSE.slice(), tintGoal = ROSE.slice(), tintMoving = false;
    var spr = null, off = null, octx = null, ro = null;
    var unsubs = [];

    /* ---------- helpers ---------- */
    function easeMorph(e) { return e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2; }
    function mix(a, b, k) { return [a[0] + (b[0] - a[0]) * k, a[1] + (b[1] - a[1]) * k, a[2] + (b[2] - a[2]) * k]; }
    function rgb(c) { return 'rgb(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ')'; }
    function rr(c, x, y, ww, hh, r) {
      c.moveTo(x + r, y); c.lineTo(x + ww - r, y); c.quadraticCurveTo(x + ww, y, x + ww, y + r);
      c.lineTo(x + ww, y + hh - r); c.quadraticCurveTo(x + ww, y + hh, x + ww - r, y + hh);
      c.lineTo(x + r, y + hh); c.quadraticCurveTo(x, y + hh, x, y + hh - r);
      c.lineTo(x, y + r); c.quadraticCurveTo(x, y, x + r, y); c.closePath();
    }

    /* Glow sprite for "hot" motes (wake / exhale), tinted with the front panel colour. */
    function buildSprite(c) {
      try {
        if (!spr) { spr = document.createElement('canvas'); spr.width = spr.height = 32; }
        var g = spr.getContext('2d'); if (!g) return;
        g.clearRect(0, 0, 32, 32);
        var grad = g.createRadialGradient(16, 16, 0, 16, 16, 16);
        var s = Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]);
        grad.addColorStop(0, 'rgba(' + s + ',1)');
        grad.addColorStop(0.35, 'rgba(' + s + ',.55)');
        grad.addColorStop(1, 'rgba(' + s + ',0)');
        g.fillStyle = grad; g.fillRect(0, 0, 32, 32);
      } catch (e) { spr = null; }
    }

    /* ---------- shape sampling (offscreen canvas → target points, local coords centred on 0,0) ---------- */
    function sample(S, draw, want) {
      var out = [];
      try {
        octx.setTransform(1, 0, 0, 1, 0, 0); octx.clearRect(0, 0, S, S);
        octx.save(); draw(octx, S); octx.restore();
        var img = octx.getImageData(0, 0, S, S).data, count = 0, i;
        for (i = 3; i < img.length; i += 4) if (img[i] > 120) count++;
        if (!count) return out;
        var st = Math.max(1, Math.round(Math.sqrt(count / Math.max(1, want))));
        var half = S / 2, x, y;
        for (y = 0; y < S; y += st) for (x = 0; x < S; x += st) {
          if (img[(y * S + x) * 4 + 3] > 120) out.push(x - half + (rnd() - 0.5) * st, y - half + (rnd() - 0.5) * st);
        }
      } catch (e) { /* tainted/unsupported canvas → shape stays empty, handled by caller */ }
      return out;
    }
    function finish(arr) {
      /* shuffle pairs so assignment to particles is random → morphs swirl instead of sliding */
      var n = arr.length / 2, i, j, tx, ty;
      for (i = n - 1; i > 0; i--) {
        j = Math.floor(rnd() * (i + 1));
        tx = arr[i * 2]; ty = arr[i * 2 + 1];
        arr[i * 2] = arr[j * 2]; arr[i * 2 + 1] = arr[j * 2 + 1];
        arr[j * 2] = tx; arr[j * 2 + 1] = ty;
      }
      return new Float32Array(arr);
    }

    function bottlePath(c, S) {
      var H = S * 0.9, W = S * 0.42, y0 = (S - H) / 2, mx = S / 2;
      c.beginPath();
      rr(c, mx - W * 0.19, y0, W * 0.38, H * 0.115, H * 0.028);               /* cap */
      rr(c, mx - W * 0.13, y0 + H * 0.125, W * 0.26, H * 0.04, H * 0.008);    /* collar */
      c.moveTo(mx - W * 0.11, y0 + H * 0.17);                                /* neck → shoulders → body */
      c.lineTo(mx + W * 0.11, y0 + H * 0.17);
      c.lineTo(mx + W * 0.11, y0 + H * 0.29);
      c.bezierCurveTo(mx + W * 0.11, y0 + H * 0.37, mx + W * 0.5, y0 + H * 0.34, mx + W * 0.5, y0 + H * 0.45);
      c.lineTo(mx + W * 0.5, y0 + H * 0.93);
      c.quadraticCurveTo(mx + W * 0.5, y0 + H, mx + W * 0.5 - H * 0.07, y0 + H);
      c.lineTo(mx - W * 0.5 + H * 0.07, y0 + H);
      c.quadraticCurveTo(mx - W * 0.5, y0 + H, mx - W * 0.5, y0 + H * 0.93);
      c.lineTo(mx - W * 0.5, y0 + H * 0.45);
      c.bezierCurveTo(mx - W * 0.5, y0 + H * 0.34, mx - W * 0.11, y0 + H * 0.37, mx - W * 0.11, y0 + H * 0.29);
      c.closePath();
    }
    function bottleLabel(c, S) {
      var H = S * 0.9, W = S * 0.42, y0 = (S - H) / 2, mx = S / 2;
      c.beginPath(); rr(c, mx - W * 0.3, y0 + H * 0.57, W * 0.6, H * 0.26, H * 0.03);
    }
    function saduSetup(c, S) {
      c.font = 'bold 220px Georgia, "Playfair Display", serif';
      c.textAlign = 'center'; c.textBaseline = 'middle';
      var tw = Math.max(1, c.measureText('SADU').width);
      var k = Math.min((S * 0.94) / tw, (S * 0.6) / 220);
      c.translate(S / 2, S / 2 + 220 * k * 0.04); c.scale(k, k);
      return k;
    }

    function buildShapes() {
      var S = Math.max(64, Math.round(size));
      if (!off) { off = document.createElement('canvas'); }
      if (off.width !== S || off.height !== S) { off.width = off.height = S; }
      try { octx = off.getContext('2d', { willReadFrequently: true }); } catch (e) { octx = off.getContext('2d'); }
      var sw = Math.max(2, S * 0.012), pts;
      shapes = {};
      if (!octx) return;

      /* (1) bottle: sparse fill + dense edge glow + label plate */
      pts = sample(S, function (c, s) { bottlePath(c, s); c.fillStyle = '#fff'; c.fill(); }, N * 0.5)
        .concat(sample(S, function (c, s) { bottlePath(c, s); c.strokeStyle = '#fff'; c.lineWidth = sw; c.stroke(); }, N * 0.36))
        .concat(sample(S, function (c, s) { bottleLabel(c, s); c.strokeStyle = '#fff'; c.lineWidth = sw * 0.8; c.stroke(); }, N * 0.14));
      shapes.bottle = finish(pts);

      /* (2) the word SADU */
      pts = sample(S, function (c, s) { saduSetup(c, s); c.fillStyle = '#fff'; c.fillText('SADU', 0, 0); }, N * 0.66)
        .concat(sample(S, function (c, s) { var k = saduSetup(c, s); c.strokeStyle = '#fff'; c.lineWidth = Math.max(2, sw / k); c.strokeText('SADU', 0, 0); }, N * 0.34));
      shapes.sadu = finish(pts);

      /* (3) thin halo: main ring + faint outer haze + delicate inner ring (analytic) */
      pts = [];
      var R = S * 0.4, i, a, r;
      for (i = 0; i < N; i++) {
        a = rnd() * TAU;
        var u = rnd();
        if (u < 0.78) r = R * (1 + (rnd() + rnd() + rnd() - 1.5) * 0.025);
        else if (u < 0.92) r = R * (1.02 + rnd() * rnd() * 0.3);
        else r = R * 0.64 * (1 + (rnd() - 0.5) * 0.02);
        pts.push(Math.cos(a) * r, Math.sin(a) * r * 0.98);
      }
      shapes.ring = finish(pts);
      shapes.vapour = null;
    }

    /* Assign a shape's points as targets; particle i takes point i mod n. */
    function assign(name, startMorph) {
      var pts = shapes[name] || null, i, n;
      if (pts && pts.length < 2) pts = null;
      for (i = 0; i < N; i++) {
        if (startMorph) { OX[i] = free ? X[i] : TX[i]; OY[i] = free ? Y[i] : TY[i]; }
      }
      if (pts) {
        n = pts.length / 2;
        for (i = 0; i < N; i++) { var j = (i % n) * 2; TX[i] = cx + pts[j]; TY[i] = cy + pts[j + 1]; }
        free = false;
      } else {
        free = true;
        if (startMorph) for (i = 0; i < N; i++) { var an = PH[i] * 3.7; VX[i] += Math.cos(an) * 0.55; VY[i] += Math.sin(an) * 0.45 - 0.25; }
      }
      shape = name;
      if (startMorph) { morphT = 0; hold = 0; }
    }

    /* ---------- layout (read rects only here) ---------- */
    function layout() {
      var r = section.getBoundingClientRect();
      w = Math.max(1, Math.round(r.width)); h = Math.max(1, Math.round(r.height));
      var bw = Math.round(w * dpr), bh = Math.round(h * dpr);
      if (canvas.width !== bw || canvas.height !== bh) { canvas.width = bw; canvas.height = bh; }
      var hr = head ? head.getBoundingClientRect() : null;
      if (hr && hr.width > 10 && hr.height > 10) { cx = hr.left - r.left + hr.width / 2; cy = hr.top - r.top + hr.height / 2; }
      else { cx = w / 2; cy = Math.min(h * 0.28, 260); }
      size = Math.min(w * 0.7, 620);
      /* keep the tallest shape (bottle, 0.9×size) inside the section instead of clipping at the top */
      var halfH = size * 0.46;
      if (cy < halfH + 8) cy = halfH + 8;
      if (h > halfH * 2 + 16 && cy > h - halfH - 8) cy = h - halfH - 8;
      /* re-sample the offscreen shapes only when the shape size actually changed (or fonts arrived):
         mobile browsers fire `resize` on every address-bar collapse while scrolling */
      var S = Math.max(64, Math.round(size));
      if (forceBuild || S !== builtSize || !shapes.bottle) { buildShapes(); builtSize = S; forceBuild = false; }
      assign(shape, false);
    }

    /* ---------- seeding ---------- */
    function seed() {
      var i, a, r;
      for (i = 0; i < N; i++) {
        a = rnd() * TAU; r = Math.sqrt(rnd()) * size * 1.1;
        X[i] = cx + Math.cos(a) * r; Y[i] = cy + Math.sin(a) * r * 0.8;
        VX[i] = VY[i] = 0;
        PH[i] = rnd() * TAU;
        SZ[i] = 1.1 + Math.pow(rnd(), 1.5) * 1.4;               /* 1.1 – 2.5px, mostly small */
        AL[i] = (0.42 + rnd() * 0.48) * ALPHA;
        DL[i] = rnd();
        CURL[i] = (rnd() - 0.5) * 0.9;
        HEAT[i] = 0;
      }
    }

    /* ---------- signature: exhale on ring snap ---------- */
    function exhale() {
      if (reduce || destroyed) return;
      pulse = 1;
      var i, dx, dy, d, q, R = size * 0.95;
      for (i = 0; i < N; i++) {
        dx = X[i] - cx; dy = Y[i] - cy; d = Math.sqrt(dx * dx + dy * dy) + 1;
        q = 1 - d / R; if (q <= 0) continue;
        q *= q; VX[i] += dx / d * q * 3.4; VY[i] += dy / d * q * 3.4;
        if (HEAT[i] < q * 0.6) HEAT[i] = q * 0.6;
      }
    }

    /* ---------- frame ---------- */
    function step(dt) {
      var f = U.clamp(dt * 60, 0.5, 2.5);
      t += dt;
      if (!free) {
        hold += dt;
        if (morphT < 9) morphT += dt;
        if (hold > HOLD[shape]) { order = (order + 1) % ORDER.length; assign(ORDER[order], true); }
      } else {
        hold += dt;
        if (hold > HOLD.vapour) { order = (order + 1) % ORDER.length; assign(ORDER[order], true); }
      }

      /* pointer velocity (per frame, for the wake) */
      var pa = !!P.active, px = P.x, py = P.y;
      if (pa) { var ddx = px - lpx, ddy = py - lpy; pspd = (lpx < -1e3) ? 0 : Math.sqrt(ddx * ddx + ddy * ddy); lpx = px; lpy = py; }
      else { pspd = 0; lpx = lpy = -1e4; }
      var rep = P.down ? REPEL_DOWN : REPEL, rep2 = rep * rep, push = P.down ? 2.2 : 1.3;
      var wake = pspd > 0.6 ? Math.min(1, 0.45 + pspd * 0.03) : 0;

      tiltX += (tiltGX - tiltX) * 0.04 * f; tiltY += (tiltGY - tiltY) * 0.04 * f;
      var damp = Math.max(0.3, 1 - 0.16 * f), fdamp = Math.max(0.5, 1 - 0.035 * f);
      var hdec = Math.pow(0.945, f);
      var morphing = morphT < MORPH_DUR + MORPH_STAGGER;
      var br = 2.4, i, x, y, gx, gy, e, ox, oy, s, ddx2, ddy2, d2, d, q, ph;
      var kx = 0.048, fx, fy, R2 = size * size * 0.42;   /* vapour containment radius ≈ 0.65×size */

      for (i = 0; i < N; i++) {
        x = X[i]; y = Y[i]; ph = PH[i];
        if (!free) {
          gx = TX[i]; gy = TY[i];
          if (morphing) {
            e = (morphT - DL[i] * MORPH_STAGGER) / MORPH_DUR;
            if (e < 1) {
              e = e <= 0 ? 0 : easeMorph(e);
              ox = OX[i]; oy = OY[i];
              s = Math.sin(e * PI) * CURL[i];                      /* curl → sweeping arc paths */
              ddx2 = gx - ox; ddy2 = gy - oy;
              gx = ox + ddx2 * e - ddy2 * s; gy = oy + ddy2 * e + ddx2 * s;
            }
          }
          gx += Math.sin(t * 0.9 + ph) * br + tiltX;
          gy += Math.cos(t * 0.7 + ph * 1.3) * br + tiltY;
          VX[i] = (VX[i] + (gx - x) * kx * f) * damp;
          VY[i] = (VY[i] + (gy - y) * kx * f) * damp;
        } else {
          /* vapour: cheap flow field + gentle rise + soft containment around the head */
          fx = Math.sin(y * 0.012 + t * 0.35 + ph) * 0.035 + Math.cos(x * 0.009 - t * 0.22 + ph * 0.8) * 0.025 + tiltGX * 0.004;
          fy = Math.cos(x * 0.011 + t * 0.28 + ph * 1.7) * 0.03 + Math.sin(t * 0.4 + ph) * 0.012 - 0.002 + tiltGY * 0.004;
          ddx2 = x - cx; ddy2 = y - cy; d2 = ddx2 * ddx2 + ddy2 * ddy2;
          q = 0.00012 + (d2 > R2 ? (d2 - R2) / R2 * 0.0016 : 0);  /* always a whisper of pull, firm past the radius */
          fx -= ddx2 * q; fy -= ddy2 * q;
          VX[i] = (VX[i] + fx * f) * fdamp;
          VY[i] = (VY[i] + fy * f) * fdamp;
        }
        /* pointer: repel + luminous wake */
        if (pa) {
          ddx2 = x - px; ddy2 = y - py; d2 = ddx2 * ddx2 + ddy2 * ddy2;
          if (d2 < rep2) {
            d = Math.sqrt(d2) + 0.01; q = 1 - d / rep; q *= q;
            VX[i] += ddx2 / d * q * push * f; VY[i] += ddy2 / d * q * push * f;
            if (wake > 0 && HEAT[i] < q * wake) HEAT[i] = q * wake;
          }
        }
        X[i] = x + VX[i] * f; Y[i] = y + VY[i] * f;
        if (HEAT[i] > 0.003) HEAT[i] *= hdec; else HEAT[i] = 0;
      }
      if (pulse > 0.001) pulse *= Math.pow(0.93, f); else pulse = 0;

      /* tint bleed toward the front panel colour */
      if (tintMoving) {
        tintCur = mix(tintCur, tintGoal, 0.06 * f);
        var dd = Math.abs(tintCur[0] - tintGoal[0]) + Math.abs(tintCur[1] - tintGoal[1]) + Math.abs(tintCur[2] - tintGoal[2]);
        if (dd < 2) { tintCur = tintGoal.slice(); tintMoving = false; }
        col[2] = rgb(tintCur);
      }
    }

    function draw() {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      var bloom = 1 + pulse * 0.55, tw = t * 2.1, i, a, s, lo, hi, b;
      for (b = 0; b < 3; b++) {
        lo = b === 0 ? 0 : (b === 1 ? B1 : B2); hi = b === 0 ? B1 : (b === 1 ? B2 : N);
        ctx.fillStyle = col[b];
        for (i = lo; i < hi; i++) {
          a = AL[i] * (0.78 + 0.22 * Math.sin(tw + PH[i] * 2)) * bloom;
          ctx.globalAlpha = a > 1 ? 1 : a;
          s = SZ[i];
          ctx.fillRect(X[i] - s * 0.5, Y[i] - s * 0.5, s, s);
        }
      }
      if (spr) {
        for (i = 0; i < N; i++) {
          if (HEAT[i] > 0.06) {
            a = HEAT[i]; ctx.globalAlpha = a * 0.9; s = 5 + a * 13;
            ctx.drawImage(spr, X[i] - s * 0.5, Y[i] - s * 0.5, s, s);
          }
        }
      }
      ctx.globalAlpha = 1;
    }

    function frame(now) {
      raf = 0;
      if (!running || destroyed) return;
      if (fOpen || grabbing) { running = false; return; }
      /* ~30fps: time-based so a 30Hz/120Hz screen or dropped frames never over-throttle (a skipped frame always re-arms rAF) */
      if (throttle && last && now - last < 26) { raf = requestAnimationFrame(frame); return; }
      var dt = last ? (now - last) / 1000 : 0.016; last = now;
      if (dt > 0.05) dt = 0.05; if (dt < 0.001) dt = 0.001;
      try { step(dt); draw(); } catch (e) { running = false; try { console.warn('[SA2 dust] stopped:', e); } catch (e2) {} return; }
      raf = requestAnimationFrame(frame);
    }
    function start() {
      if (destroyed || reduce || running || paused || !visible || fOpen || grabbing) return;
      running = true; last = 0;
      if (!raf) raf = requestAnimationFrame(frame);
    }
    function stop() {
      running = false;
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
    }
    function clear() { try { ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, canvas.width, canvas.height); } catch (e) {} }

    /* Reduced motion: particles sit on the shape, drawn once. */
    function drawStatic() {
      var i; for (i = 0; i < N; i++) { X[i] = TX[i]; Y[i] = TY[i]; HEAT[i] = 0; }
      pulse = 0;
      try { if (fOpen) clear(); else draw(); } catch (e) {}
    }

    /* ---------- events ---------- */
    function onResize() {
      if (resizeQueued || destroyed) return;
      resizeQueued = requestAnimationFrame(function () { resizeQueued = 0; api.resize(); });
    }
    /* perf lite: the ring drag gets the whole frame budget — freeze the dust while the section is grabbed */
    function onGrab() {
      var g = section.classList.contains('is-grabbing');
      if (g === grabbing) return;
      grabbing = g;
      if (g) stop(); else start();
    }
    function onTilt(e) {
      if (e == null || e.gamma == null || e.beta == null) return;
      tiltGX = U.clamp(e.gamma / 40, -1, 1) * 12;
      tiltGY = U.clamp((e.beta - 50) / 40, -1, 1) * 8;
    }

    /* ---------- init ---------- */
    try {
      layout();
      seed();
      if (glow) buildSprite(mix(ROSE, DEEP, 0.3));
      if (reduce) {
        assign('bottle', false); drawStatic();
      } else {
        /* entrance: scattered motes gather into the bottle on first sight */
        var i; for (i = 0; i < N; i++) { OX[i] = X[i]; OY[i] = Y[i]; }
        free = false; shape = 'bottle'; morphT = 0; hold = 0;
      }

      unsubs.push(U.onVisible(section, function (v) { visible = v; if (v) start(); else stop(); }));
      unsubs.push(U.on('finder', function (e) {
        var open = !!(e && e.detail && e.detail.open);
        fOpen = open;
        if (open) { stop(); clear(); } else { if (reduce) drawStatic(); else start(); }
      }));
      unsubs.push(U.on('front', function (e) {
        var d = e && e.detail; if (!d || !d.tint) return;
        try { tintGoal = mix(U.hexToRgb(d.tint), DEEP, 0.5); tintMoving = true; if (glow) buildSprite(mix(U.hexToRgb(d.tint), DEEP, 0.28)); } catch (err) {}
        if (reduce) { tintCur = tintGoal.slice(); tintMoving = false; col[2] = rgb(tintCur); drawStatic(); }
      }));
      unsubs.push(U.on('snap', exhale));
      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('orientationchange', onResize, { passive: true });
      /* section height can change without a window resize (images/fonts arriving) — silk and ring watch it too */
      try { if ('ResizeObserver' in window) { ro = new ResizeObserver(onResize); ro.observe(section); } } catch (e) { ro = null; }
      if (touch && !reduce && !lite && 'DeviceOrientationEvent' in window) window.addEventListener('deviceorientation', onTilt, { passive: true });
      if (lite && !reduce) {
        try { if ('MutationObserver' in window) { mo = new MutationObserver(onGrab); mo.observe(section, { attributes: true, attributeFilter: ['class'] }); onGrab(); } } catch (e) { mo = null; }
      }
      /* if Georgia is missing and Playfair arrives late, re-sample the word once */
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(function () { if (!destroyed) { forceBuild = true; onResize(); } }).catch(function () {});
      }
    } catch (err) {
      try { console.warn('[SA2 dust] degraded:', err); } catch (e2) {}
    }

    /* ---------- API ---------- */
    api.pause = function () { paused = true; stop(); };
    api.resume = function () { paused = false; if (reduce) drawStatic(); else start(); };
    api.resize = function () {
      if (destroyed) return;
      try {
        layout();
        if (reduce) drawStatic();
        /* frozen by a ring grab (perf lite): the backing-store reset just wiped the canvas — repaint the held frame */
        else if (grabbing && !fOpen && !running) draw();
      } catch (e) {}
    };
    api.morphTo = function (name) {
      if (destroyed || !name) return;
      name = String(name).toLowerCase();
      var idx = ORDER.indexOf(name); if (idx < 0) return;
      order = idx;
      if (reduce) { assign(name, false); drawStatic(); return; }
      assign(name, true);
      start();
    };
    api.shape = function () { return shape; };
    api.destroy = function () {
      destroyed = true; stop();
      if (resizeQueued) { cancelAnimationFrame(resizeQueued); resizeQueued = 0; }
      unsubs.forEach(function (u) { try { u(); } catch (e) {} });
      unsubs.length = 0;
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
      window.removeEventListener('deviceorientation', onTilt);
      try { if (ro) ro.disconnect(); } catch (e) {} ro = null;
      try { if (mo) mo.disconnect(); } catch (e) {} mo = null;
      clear();
    };
    return api;
  });
})();


/* ===== sa2-ring.js ===== */
/* SADU Atelier 2.0 — ring: 3D ring of glass portals.
   Entrance choreography, drag/inertia/snap, dots, keyboard, mobile gyroscope, desktop parallax, haptics.
   Signature extras: "liquid lean" (panels lag into a turn like glass through perfume) and "exhale"
   (the resting front portal breathes toward you). Transform/opacity/filter only; no per-frame layout reads. */
(function () {
  if (!window.SA2 || typeof SA2.register !== 'function') return;
  SA2.register('ring', function (section) {
    var U = SA2.util, ST = SA2.state, P = SA2.pointer;
    var noop = function () {};
    var api = { pause: noop, resume: noop, resize: noop, destroy: noop, goTo: noop, rotation: function () { return 0; } };
    var q = function (sel, root) { try { return (root || section).querySelector(sel); } catch (e) { return null; } };
    var qa = function (sel, root) { try { return Array.prototype.slice.call((root || section).querySelectorAll(sel)); } catch (e) { return []; } };

    var stage = q('[data-sa2-stage]'), ringEl = q('[data-sa2-ring]'), aura = q('[data-sa2-aura]');
    var panels = ringEl ? qa('[data-sa2-panel]', ringEl) : [];
    var dots = qa('[data-goto]', q('[data-sa2-dots]') || section);
    if (!stage || !ringEl || !panels.length) return api;

    var n = panels.length, step = 360 / n;
    var reduce = !!U.reduce, touch = !!U.isTouch;
    var accent = section.getAttribute('data-accent') || '#caa86a';
    /* data-perf="lite" (default) | "full": global low-power switch. Only bites on phones (see `lite` below). */
    var perfLite = (section.getAttribute('data-perf') || 'lite') !== 'full';
    /* section data attributes (rendered by Liquid, read once) */
    var num = function (attr, def, lo, hi) { var v = parseFloat(section.getAttribute(attr)); return isNaN(v) ? def : U.clamp(v, lo, hi); };
    var MOTION = (section.getAttribute('data-ring-motion') || 'step') === 'drift' ? 'drift' : 'step';   // "step": rest, swing to the next panel every INTERVAL · "drift": continuous
    var INTERVAL_MS = num('data-ring-interval', 3.5, 2, 8) * 1000;   // step mode: seconds of rest between steps
    var SPEED = num('data-ring-speed', 4, 1, 10) * 1.2;              // drift mode: deg per SECOND (4 → 4.8°/s ≈ 9 s per card)
    var MOB_CARD = num('data-mobile-card', 50, 40, 70) / 100;        // phones: front panel width as a fraction of the stage width
    var MOB_3D = num('data-mobile-3d', 7, 1, 10);                    // phones: depth 1..10 → shorter perspective + flatter facing curve

    /* tuning — every rate below is per SECOND or per normalised 60fps frame (k = dt/16.667), so a 30fps throttle never changes speed */
    var FRICTION = 0.94;    // inertia decay per normalised frame (vel is deg per normalised frame; rot += vel*k → time-based)
    var IDLE_MS = 2600;     // drift mode: wait before auto-rotate resumes
    var STEP_MS = 850;      // step mode: duration of one eased swing to the next panel
    var STEP_PAUSE_MS = 6000;   // step mode: stepping pauses this long after any user interaction
    var FACE_K = 58;        // portals turn back toward the viewer: net turn = d - FACE_K*sin(d) (seamless around the ring); phones use faceK (layout)
    var LEAN_MAX = 8;       // liquid-lean cap (deg)
    var ENTER_MS = 1100, STAGGER = 70;
    var LITE_BLUR_MAX = 0, LITE_BLUR_STEP = 0.4;   // 0 = no filter at all on phones (owner reported the ring still slow)   // low-power: blur on 3D-transformed panels is the costliest paint on mid phones
    var LITE_ENTER_MS = 500, LITE_STAGGER = 30, LITE_RISE = 28;   // low-power entrance: plain fade + rise, no scatter/rotation

    /* state */
    var rot = 0, vel = 0, mode = 'idle', snapTarget = 0, tween = null;
    var pw = 220, R = 500, desk = false, phone = false, sw = 1, sh = 1, sx = 0, sy = 0, degPerPx = 0.2;
    var faceK = FACE_K, opK = 0.75;       // facing curve + opacity falloff (1 → 1-opK by angular distance); phone values set in layout()
    var lite = false, skipTick = false;   // lite = perfLite && on a phone (recomputed in layout); skipTick = 30fps coasting toggle
    var front = -1, lastInteract = 0, userAt = 0, stepAt = 0, wakeTimer = 0;   // stepAt = when the next auto-step fires (0 = none pending)
    var hover = false, entered = reduce, entering = false, pendingEnt = 0;
    var visible = false, paused = false, finderOpen = !!ST.finderOpen, destroyed = false, raf = 0, last = 0, warned = false;
    var tiltX = 0, tiltY = 0, gyro = 0, gyroT = 0, gyroBase = null, gyroAt = 0, leanS = 0, exhale = 0, breath = 0;
    var gsx = 0, gsy = 0, gsxT = 0, gsyT = 0, gbBase = 45, ggBase = 0;   // phone gyro STAGE tilt (composed into the ring transform) + slow re-centre bases
    var drag = null, dragAcc = 0, suppressUntil = 0, rTimer = 0;
    var ringTr = '', auraX = null, auraOwnsTr = false;
    var offs = [];

    var items = panels.map(function (el, i) {
      return { el: el, i: i, tr: '', op: '', fl: '', z: '', gx: '', ent: null,
        name: el.getAttribute('data-name') || ('Collection ' + (i + 1)),
        tint: el.getAttribute('data-tint') || accent };
    });

    /* helpers */
    var now = function () { return performance.now(); };
    var wrap = function (a) { a = a % 360; if (a > 180) a -= 360; else if (a < -180) a += 360; return a; };
    var nearest = function (r) { return Math.round(r / step) * step; };
    var frontIndex = function () { return ((Math.round(-rot / step) % n) + n) % n; };
    var onGrid = function () { return Math.abs(rot - nearest(rot)) < 0.5; };
    var easeOutQuint = function (p) { return 1 - Math.pow(1 - p, 5); };
    var easeInOutCubic = function (p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; };
    var spring = function (p) { return p >= 1 ? 1 : 1 - Math.exp(-6.5 * p) * Math.cos(6.2 * p); };
    /* smoothing factor `a` per 60fps frame, made exact for any dt: 1-(1-a)^k (30fps and 120Hz land on the same curve) */
    var sm = function (a, k) { return k === 1 ? a : 1 - Math.pow(1 - a, k); };
    var closestPanel = function (t) { return t && t.closest ? t.closest('[data-sa2-panel]') : null; };
    var listen = function (t, ev, fn, opt) { t.addEventListener(ev, fn, opt); offs.push(function () { t.removeEventListener(ev, fn, opt); }); };
    var active = function () { return !destroyed && visible && !paused && !finderOpen; };
    var clearWake = function () { if (wakeTimer) { clearTimeout(wakeTimer); wakeTimer = 0; } };
    function start() { clearWake(); if (!raf && active()) { last = now(); raf = requestAnimationFrame(frame); } }
    function stop() { clearWake(); stepAt = 0; if (raf) { cancelAnimationFrame(raf); raf = 0; } }   // stepAt = 0: a resume rests a full interval before stepping
    /* step mode: any user interaction cancels the pending step and pauses stepping for STEP_PAUSE_MS */
    function userTouch(t) { lastInteract = userAt = t; stepAt = 0; }
    function scheduleStep(t) { stepAt = Math.max(t + INTERVAL_MS, userAt ? userAt + STEP_PAUSE_MS : 0); }   // userAt = 0 → nobody touched it yet: plain interval

    /* layout: the only place we read rects */
    function layout() {
      try {
        var r = stage.getBoundingClientRect(), sr = section.getBoundingClientRect();
        sw = r.width || 1; sh = r.height || 1; sx = r.left - sr.left; sy = r.top - sr.top;
        desk = U.isDesk();
        phone = touch || !desk;               // phone = touch or narrow viewport (same definition as elsewhere)
        lite = perfLite && phone;             // desktop "full" behaviour stays untouched
        pw = phone ? Math.min(sw * MOB_CARD, 300) : U.clamp(sw * 0.17, 190, 250);
        R = pw * (phone ? 0.62 : 0.82) / Math.tan(Math.PI / Math.max(n, 3));
        degPerPx = step / (pw * 0.95);
        /* phones: real depth — shorter perspective, side panels keep a real angle (smaller facing curve), neighbours stay visible */
        faceK = phone ? FACE_K - MOB_3D * 5 : FACE_K;
        opK = phone ? 0.45 : 0.75;
        var persp = phone ? Math.round(1400 - MOB_3D * 90) + 'px' : '';
        if (stage.style.perspective !== persp) stage.style.perspective = persp;
        section.style.setProperty('--pw', Math.round(pw) + 'px');
      } catch (e) {}
    }

    function setFront(i) {
      if (front >= 0 && items[front]) items[front].el.classList.remove('is-front');
      front = i; var it = items[i]; it.el.classList.add('is-front');
      ST.front = i; ST.tint = it.tint;
      if (aura) aura.style.setProperty('--aura', it.tint);
      section.style.setProperty('--sa2-tint', it.tint);
      dots.forEach(function (b) {
        var on = parseInt(b.getAttribute('data-goto'), 10) === i;
        b.classList.toggle('is-on', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      U.emit('front', { index: i, name: it.name, tint: it.tint, el: it.el });
    }

    function settle(t, auto) {
      mode = 'idle'; vel = 0; tween = null; lastInteract = t; breath = 0;
      if (rot > 1e5 || rot < -1e5) rot = rot % 360;   // step mode walks forever; keep the number small (360 = n*step, grid preserved)
      var fi = frontIndex(); if (fi !== front) setFront(fi);
      U.emit('snap', { index: fi });
      if (touch && !auto) U.haptic(8);   // no buzz on the automatic steps
      if (MOTION === 'step') scheduleStep(t);
    }
    /* step mode: one eased swing to the NEXT panel (the ring turns through the 3D arc, then rests) */
    function stepNext(t) {
      stepAt = 0;
      tween = { from: rot, to: nearest(rot) - step, t0: t, dur: STEP_MS, ease: easeInOutCubic, auto: true };
      mode = 'goto';
    }

    /* entrance: scattered → spring into place, front-most first */
    function primeEntrance() {
      if (reduce) return;
      var rnd = U.prng(U.hash(section.id || 'sa2-ring'));
      items.forEach(function (it) {
        /* low-power: no scatter/rotation — every panel simply rises LITE_RISE px and fades in */
        if (lite) { it.ent = { lite: true, tx: 0, ty: LITE_RISE, tz: 0, rz: 0, t0: Infinity }; return; }
        it.ent = { lite: false, tx: (rnd() - 0.5) * 2 * Math.max(160, sw * 0.55), ty: (rnd() - 0.5) * 2 * Math.max(120, sh * 0.4),
          tz: -260 + rnd() * 420, rz: (rnd() - 0.5) * 70, t0: Infinity };
      });
      pendingEnt = n;
    }
    function startEntrance(t) {
      entering = true;
      if (!pendingEnt) { entered = true; entering = false; return; }
      var order = items.slice().sort(function (a, b) { return Math.abs(wrap(a.i * step + rot)) - Math.abs(wrap(b.i * step + rot)); });
      order.forEach(function (it, k) { if (it.ent) it.ent.t0 = t + (it.ent.lite ? 60 + k * LITE_STAGGER : 120 + k * STAGGER); });
    }

    /* motion (k = dt/16.667 normalised frame, dt = real ms between painted frames) */
    function physics(t, k, dt) {
      if (mode === 'drag') {
        var dr = dragAcc * degPerPx; dragAcc = 0; rot += dr;
        vel = U.clamp(U.lerp(vel, dr / k, sm(0.45, k)), -14, 14);
      } else if (mode === 'inertia') {
        rot += vel * k; vel *= Math.pow(FRICTION, k);
        if (Math.abs(vel) < 0.05) { mode = 'snap'; snapTarget = nearest(rot + vel * 8); }
      } else if (mode === 'snap') {
        var d = snapTarget - rot;
        if (reduce) { rot = snapTarget; settle(t); }
        else { rot += d * sm(0.16, k); if (Math.abs(d) < 0.03) { rot = snapTarget; settle(t); } }
      } else if (mode === 'goto') {
        if (!tween) { mode = 'idle'; }
        else {
          var p = U.clamp((t - tween.t0) / tween.dur, 0, 1);
          rot = tween.from + (tween.to - tween.from) * (tween.ease || easeOutQuint)(p);
          if (p >= 1) { var au = !!tween.auto; rot = tween.to; settle(t, au); }
        }
      } else if (entered && !hover && !reduce) {
        if (MOTION === 'drift') {
          /* continuous drift: SPEED deg per second of real time */
          if (t - lastInteract > IDLE_MS) { rot += SPEED * dt / 1000; if (rot > 1e5 || rot < -1e5) rot = rot % 360; }
        } else {
          /* step: rest on a panel, swing to the next one when the interval elapses */
          if (!stepAt) scheduleStep(t);
          else if (t >= stepAt) stepNext(t);
        }
      }
    }

    function render(t, k, dt) {
      var fi = frontIndex(); if (fi !== front) setFront(fi);

      /* desktop parallax toward the pointer */
      var tX = 0, tY = 0;
      if (desk && !touch && !reduce && P.active) {
        var nx = U.clamp((P.x - (sx + sw / 2)) / (sw / 2), -1, 1), ny = U.clamp((P.y - (sy + sh / 2)) / (sh / 2), -1, 1);
        tY = nx * 6; tX = -ny * 4;
      }
      var s06 = sm(0.06, k), s08 = sm(0.08, k);
      tiltX += (tX - tiltX) * s06;
      tiltY += (tY - tiltY) * s06;
      gyro += (gyroT - gyro) * s08;
      /* phone gyro stage tilt: the whole ring container leans with the phone (0 on desktop, string unchanged there) */
      gsx += (gsxT - gsx) * s08;
      gsy += (gsyT - gsy) * s08;

      /* liquid lean: panels lag into the turn, more so the further from the front */
      var leanT = (mode === 'drag' || mode === 'inertia') ? U.clamp(-vel * 1.3, -LEAN_MAX, LEAN_MAX) : 0;
      leanS += (leanT - leanS) * sm(0.18, k);
      if (Math.abs(leanS) < 0.01) leanS = 0;

      /* exhale: the resting front portal breathes toward the viewer (off in low-power: it re-rasterises the front panel every frame) */
      var resting = mode === 'idle' && entered && !reduce && !lite && onGrid();
      if (resting) { breath += dt / 3600 * Math.PI * 2; exhale += (1 - exhale) * sm(0.04, k); }
      else exhale += (0 - exhale) * sm(0.12, k);
      if (exhale < 0.002) exhale = 0;
      var ex = exhale * (desk ? 18 : 12) * (0.5 - 0.5 * Math.cos(breath));

      var tr = 'rotateX(' + (tiltX + gsx).toFixed(2) + 'deg) rotateY(' + (tiltY + gsy).toFixed(2) + 'deg) translateZ(' + (-R).toFixed(1) + 'px) rotateY(' + (rot + gyro).toFixed(2) + 'deg)';
      if (tr !== ringTr) { ringEl.style.transform = tr; ringTr = tr; }

      /* low-power: the aura is a huge blurred glow — do not shift it while a finger is dragging the ring */
      if (aura && !(lite && mode === 'drag')) {
        var ax = Math.round(gyro * 3 + tiltY * 2.5);
        if (ax !== auraX) {
          auraX = ax; aura.style.setProperty('--aura-x', ax + 'px');
          if (auraOwnsTr) aura.style.transform = 'translate3d(' + ax + 'px,0,0)';
        }
      }

      var coasting = mode === 'drag' || mode === 'inertia';
      for (var i = 0; i < n; i++) {
        var it = items[i], a = i * step;
        var d = wrap(a + rot + gyro), ad = Math.abs(d) / 180, rad = d * Math.PI / 180;
        var face = -faceK * Math.sin(rad) + leanS * (0.55 + 0.45 * ad);
        var z = R + (i === front ? ex : 0);
        var ptr = 'rotateY(' + a.toFixed(2) + 'deg) translateZ(' + z.toFixed(1) + 'px) rotateY(' + face.toFixed(2) + 'deg)';
        var op = 1 - opK * ad, bl = 3.2 * ad * ad;   // opacity floor: desktop .25, phones .55 (neighbours stay visible)
        if (it.ent) {
          if (it.ent.lite) {
            /* low-power entrance: ~500ms fade + rise, one translate, no spring/scale/rotation */
            var pl = U.clamp((t - it.ent.t0) / LITE_ENTER_MS, 0, 1), ul = 1 - easeOutQuint(pl);
            ptr += ' translate3d(0,' + (it.ent.ty * ul).toFixed(1) + 'px,0)';
            op *= pl;
            if (pl >= 1) { it.ent = null; if (--pendingEnt <= 0) { pendingEnt = 0; entered = true; entering = false; lastInteract = t; } }
          } else {
            var p = U.clamp((t - it.ent.t0) / ENTER_MS, 0, 1), s = spring(p), u = 1 - s;
            ptr += ' translate3d(' + (it.ent.tx * u).toFixed(1) + 'px,' + (it.ent.ty * u).toFixed(1) + 'px,' + (it.ent.tz * u).toFixed(1) + 'px) rotateZ(' + (it.ent.rz * u).toFixed(2) + 'deg) scale(' + (0.3 + 0.7 * s).toFixed(3) + ')';
            op *= U.clamp(p * 2.2, 0, 1);
            if (p >= 1) { it.ent = null; if (--pendingEnt <= 0) { pendingEnt = 0; entered = true; entering = false; lastInteract = t; } }
          }
        }
        if (lite) bl = Math.round(Math.min(bl, LITE_BLUR_MAX) / LITE_BLUR_STEP) * LITE_BLUR_STEP;   // low-power: cap 1.2px, 0.4px steps (0/.4/.8/1.2)
        else if (touch) bl = Math.round(bl * 5) / 5;   // coarser blur steps on phones = fewer re-rasterisations
        var ops = op.toFixed(2);
        var fls = bl < 0.15 ? '' : 'blur(' + bl.toFixed(1) + 'px)';
        var zs = String(Math.round((1 - ad) * 100) + 1);
        var st = it.el.style;
        if (ptr !== it.tr) { st.transform = ptr; it.tr = ptr; }
        if (ops !== it.op) { st.opacity = ops; it.op = ops; }
        if (fls !== it.fl) { st.filter = fls; it.fl = fls; }
        if (zs !== it.z) { st.zIndex = zs; it.z = zs; }
        /* low-power: freeze the glare streak while dragging/coasting (the lean-driven --gx repaints every panel per frame); it catches up on snap */
        if (!(lite && coasting)) {
          var gx = String(U.clamp(Math.round(50 + 42 * Math.sin(rad) + leanS * 1.5), 0, 100));
          if (gx !== it.gx) { st.setProperty('--gx', gx + '%'); it.gx = gx; }
        }
      }
    }

    function frame(t) {
      raf = 0;
      if (!active()) return;
      /* low-power: while idle + settled (drift: only the auto-rotate running; step: resting, gyro tilt painting), paint at
         30fps (every other frame). `last` is left alone on the skipped frame so the next one gets the accumulated dt —
         all motion is per real ms, so the throttle never changes speed. Drags, inertia, snap and tweens keep the full rate. */
      var idleRest = lite && mode === 'idle' && !drag && !tween && entered && !entering && !hover && !reduce;
      var autoOnly = idleRest && (MOTION === 'step' || t - lastInteract > IDLE_MS);
      if (autoOnly) { skipTick = !skipTick; if (skipTick) { raf = requestAnimationFrame(frame); return; } }
      else skipTick = false;
      var dt = Math.min(100, Math.max(1, t - last)); last = t; var k = dt / 16.667;
      try { physics(t, k, dt); render(t, k, dt); }
      catch (err) { if (!warned) { warned = true; console.warn('[SA2 ring] frame', err); } }
      /* reduced motion: nothing drifts, breathes or tilts at rest — let the loop sleep; interactions call start() */
      if (reduce && mode === 'idle' && !drag) return;
      /* phone, step mode, resting, no gyro data arriving and every smoothed value settled: sleep until the next step
         (a timer wakes the loop; gyro events and interactions call start() too) */
      if (idleRest && MOTION === 'step' && mode === 'idle' && stepAt > 0 && !(gyroAt && t - gyroAt < 1200) &&
          Math.abs(gyro - gyroT) < 0.05 && Math.abs(gsx - gsxT) < 0.05 && Math.abs(gsy - gsyT) < 0.05 && !leanS && !exhale) {
        clearWake();
        wakeTimer = setTimeout(function () { wakeTimer = 0; start(); }, Math.max(16, stepAt - now()));
        return;
      }
      raf = requestAnimationFrame(frame);
    }

    /* navigation */
    function goTo(i) {
      if (destroyed || typeof i !== 'number' || isNaN(i)) return;
      i = ((Math.round(i) % n) + n) % n;
      var t = now(), to = rot + wrap(-i * step - rot);
      drag = null; dragAcc = 0; section.classList.remove('is-grabbing'); vel = 0; userTouch(t);
      if (Math.abs(to - rot) < 0.01) { mode = 'idle'; tween = null; return; }
      if (reduce) { rot = to; settle(t); render(t, 1, 16); return; }
      tween = { from: rot, to: to, t0: t, dur: 480 + 110 * Math.min(4, Math.abs(to - rot) / step) };
      mode = 'goto'; start();
    }

    /* pointer drag with inertia */
    function onDown(e) {
      if (destroyed || finderOpen || drag) return;   // one pointer at a time (second finger is ignored)
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, lx: e.clientX, moved: 0, captured: false };
      dragAcc = 0; vel = 0; tween = null; mode = 'drag'; userTouch(now());
      section.classList.add('is-grabbing');
      /* NOTE: no setPointerCapture here — capturing on pointerdown retargets the following `click`
         to the stage, which kills the panel link tap. We capture only once a real drag is detected. */
      start();
    }
    function onMove(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.lx; drag.lx = e.clientX; dragAcc += dx;
      var m = Math.abs(e.clientX - drag.x0) + Math.abs(e.clientY - drag.y0);
      if (m > drag.moved) drag.moved = m;
      if (!drag.captured && m > 6) {
        drag.captured = true;
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
    }
    function endDrag(e, cancelled) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var moved = drag.moved, captured = drag.captured; drag = null;
      section.classList.remove('is-grabbing');
      if (e && captured) { try { stage.releasePointerCapture(e.pointerId); } catch (err) {} }
      userTouch(now());
      if (moved > 6) suppressUntil = lastInteract + 400;
      if (cancelled) { vel = 0; dragAcc = 0; }
      if (moved <= 6 && onGrid()) { mode = 'idle'; vel = 0; dragAcc = 0; return; }
      if (dragAcc) { rot += dragAcc * degPerPx; dragAcc = 0; }
      mode = 'inertia';
    }

    function bind() {
      listen(stage, 'pointerdown', onDown);
      listen(stage, 'pointermove', onMove, { passive: true });
      listen(stage, 'pointerup', function (e) { endDrag(e, false); });
      listen(stage, 'pointercancel', function (e) { endDrag(e, true); });
      listen(window, 'pointerup', function (e) { if (drag && e.pointerId === drag.id) endDrag(e, false); }, { passive: true });
      listen(ringEl, 'dragstart', function (e) { e.preventDefault(); });
      /* swallow the click that follows a real drag */
      listen(stage, 'click', function (e) { if (now() < suppressUntil) { e.preventDefault(); e.stopPropagation(); } }, true);
      /* tapping a side portal turns it to the front instead of navigating */
      listen(ringEl, 'click', function (e) {
        var a = closestPanel(e.target); if (!a) return;
        var i = panels.indexOf(a); if (i < 0 || i === front) return;
        e.preventDefault(); goTo(i);
      });
      listen(ringEl, 'focusin', function (e) {
        if (drag) return;   // mousedown focuses the link mid-drag; only keyboard/programmatic focus should turn the ring
        var a = closestPanel(e.target); if (!a) return;
        var i = panels.indexOf(a); if (i >= 0 && i !== front) goTo(i);
      });
      if (!touch) {
        listen(stage, 'pointerenter', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          hover = true;
          if (mode === 'idle' && !onGrid()) { mode = 'snap'; snapTarget = nearest(rot); start(); }
        });
        listen(stage, 'pointerleave', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          hover = false; lastInteract = now(); stepAt = 0;   // step mode: re-arm a full interval after the hover pause
        });
      }
      /* keyboard */
      if (!stage.hasAttribute('tabindex')) stage.setAttribute('tabindex', '0');
      if (!stage.hasAttribute('role')) stage.setAttribute('role', 'group');
      if (!stage.hasAttribute('aria-label')) stage.setAttribute('aria-label', 'Collections ring. Use the left and right arrow keys to turn it.');
      listen(stage, 'keydown', function (e) {
        var i = null;
        if (e.key === 'ArrowLeft') i = front - 1;
        else if (e.key === 'ArrowRight') i = front + 1;
        else if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = n - 1;
        else if (e.key === 'Enter' && e.target === stage) { var f = items[front]; if (f && typeof f.el.click === 'function') f.el.click(); return; }
        if (i === null) return;
        e.preventDefault(); goTo(i);
      });
      /* dots */
      dots.forEach(function (b) {
        listen(b, 'click', function (e) {
          e.preventDefault();
          var i = parseInt(b.getAttribute('data-goto'), 10);
          if (!isNaN(i)) goTo(i);
        });
      });
      /* resize: relayout (debounced) */
      var onResize = function () { clearTimeout(rTimer); rTimer = setTimeout(function () { if (destroyed) return; layout(); render(now(), 1, 16); }, 120); };
      listen(window, 'resize', onResize, { passive: true });
      listen(window, 'orientationchange', onResize, { passive: true });
      if (window.ResizeObserver) {
        try { var ro = new ResizeObserver(onResize); ro.observe(stage); offs.push(function () { ro.disconnect(); }); } catch (e) {}
      }
    }

    /* mobile gyroscope → subtle ring offset (±12°), aura shift, and a stage tilt of the whole ring (rotateX/rotateY) */
    function gyroInit() {
      if (!touch || reduce) return;
      var DOE = window.DeviceOrientationEvent;
      if (!DOE) return;
      var attach = function () { listen(window, 'deviceorientation', onOrient, { passive: true }); };
      if (typeof DOE.requestPermission === 'function') {
        /* iOS: requestPermission() only resolves inside a user activation. `touchstart` is NOT an
           activation-triggering event (touchend / click are), so ask on the first tap's end. */
        var asked = false;
        var ask = function () {
          if (asked || destroyed) return; asked = true;
          try {
            DOE.requestPermission().then(function (s) { if (s === 'granted' && !destroyed) attach(); })
              .catch(function () { asked = false; });   // rejected (no gesture) → allow a retry on the next tap
          } catch (e) { asked = false; }
        };
        listen(stage, 'touchend', ask, { passive: true });
        listen(stage, 'click', ask);
      } else attach();
    }
    function onOrient(e) {
      var land = (screen.orientation && typeof screen.orientation.angle === 'number') ? (screen.orientation.angle % 180 !== 0) : (window.innerWidth > window.innerHeight);
      var g = land ? e.beta : e.gamma;
      /* stage tilt: beta (front/back, rest pose ~45°) → rotateX, gamma (left/right) → rotateY; bases re-centre slowly like gyroBase */
      var b = e.beta, gg = e.gamma;
      if (b != null && !isNaN(b) && gg != null && !isNaN(gg)) {
        gbBase += (b - gbBase) * 0.004; ggBase += (gg - ggBase) * 0.004;
        gsxT = U.clamp(b - gbBase, -30, 30) * 0.2;
        gsyT = U.clamp(gg - ggBase, -30, 30) * 0.25;
        gyroAt = now();
        start();   // a sleeping (step-mode, resting) loop wakes to paint the tilt; no-op while already running
      }
      if (g == null || isNaN(g)) return;
      if (gyroBase === null) gyroBase = g;
      gyroBase += (g - gyroBase) * 0.004;      // slow re-centre so a held tilt fades back to rest
      var d = g - gyroBase; if (d > 180) d -= 360; else if (d < -180) d += 360;
      gyroT = U.clamp(d / 30, -1, 1) * 12;
    }

    function destroy() {
      destroyed = true; stop(); clearTimeout(rTimer);
      offs.forEach(function (f) { try { f(); } catch (e) {} }); offs = [];
      section.classList.remove('is-grabbing');
      section.style.removeProperty('--pw'); section.style.removeProperty('--sa2-tint');
      items.forEach(function (it) {
        var s = it.el.style; s.transform = ''; s.opacity = ''; s.filter = ''; s.zIndex = ''; s.removeProperty('--gx');
        it.el.classList.remove('is-front');
      });
      dots.forEach(function (b) { b.classList.remove('is-on'); b.removeAttribute('aria-current'); });
      if (aura) { aura.style.removeProperty('--aura'); aura.style.removeProperty('--aura-x'); if (auraOwnsTr) aura.style.transform = ''; }
      ringEl.style.transform = ''; ringEl.style.willChange = '';
      stage.style.perspective = '';
    }

    /* init */
    try {
      layout();
      primeEntrance();
      if (aura) { try { var atr = getComputedStyle(aura).transform; auraOwnsTr = !atr || atr === 'none'; } catch (e) { auraOwnsTr = false; } }
      ringEl.style.willChange = 'transform';
      bind();
      gyroInit();
      setFront(frontIndex());
      render(now(), 1, 16);
      offs.push(U.onVisible(stage, function (v) {
        visible = v;
        if (v) { if (!entered && !entering) startEntrance(now()); start(); }
        else stop();
      }));
      offs.push(U.on('finder', function (e) {
        finderOpen = !!(e.detail && e.detail.open);
        if (finderOpen) { if (drag) endDrag(null, true); stop(); }
        else start();
      }));
    } catch (err) { console.warn('[SA2 ring] init', err); }

    api.pause = function () { paused = true; stop(); };
    api.resume = function () { paused = false; start(); };
    api.resize = function () { layout(); render(now(), 1, 16); };
    api.destroy = destroy;
    api.goTo = goTo;
    api.rotation = function () { return rot; };
    return api;
  });
})();


/* ===== sa2-finder.js ===== */
/* SADU Atelier 2.0 — finder: "Find my scent" 2.0 (3 taps · describe-it search · generative SCENT DNA).
   Signature micro-interaction: the "scent ledger" — every answer releases a tinted vapour puff that flies into
   its progress segment; the three tints then blend into the atmosphere of the result card. */
(function () {
  if (!window.SA2 || typeof SA2.register !== 'function') return;

  SA2.register('finder', function (section) {
    var U = SA2.util, ST = SA2.state;
    var noop = function () {};
    var api = { pause: noop, resume: noop, resize: noop, destroy: noop, open: noop, close: noop, isOpen: function () { return false; } };
    var overlay = section.querySelector('[data-sa2-finder]');
    if (!overlay) return api;

    var uid = (section.id || 'sa2') + '-f';
    var GOLD = '#caa86a', DEEP = '#8a6d3b';
    var root = '/';
    try {
      var rr = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (typeof rr === 'string' && rr.charAt(0) === '/') root = rr.replace(/\/?$/, '/');
    } catch (e) {}

    /* ---------- data ---------- */
    var WHO = [
      { id: 'Men', label: 'Him', sub: 'Woods, leather, cool spice', tint: '#cfe1ec', rings: 5 },
      { id: 'Women', label: 'Her', sub: 'Petals, musk, warm sugar', tint: '#f4d6cc', rings: 7 },
      { id: 'Unisex', label: 'Anyone', sub: 'Shared, modern, unbound', tint: '#f7e6c9', rings: 6 }
    ];
    var MOOD = [
      { id: 'fresh-collection', family: 'Fresh', label: 'Fresh & clean', sub: 'Citrus, sea air, linen', tint: '#cfe1ec', petals: 6, copy: 'Bright, airy and effortlessly clean' },
      { id: 'oriental-collection', family: 'Oriental', label: 'Warm & sensual', sub: 'Amber, vanilla, spice', tint: '#f5e4bf', petals: 9, copy: 'Warm amber and spice that lingers on skin' },
      { id: 'gourmand-collection', family: 'Gourmand', label: 'Sweet & addictive', sub: 'Caramel, praline, tonka', tint: '#f6dcd2', petals: 8, copy: 'Sweet, creamy and impossible to forget' },
      { id: 'woody-collection', family: 'Woody', label: 'Deep & elegant', sub: 'Sandalwood, vetiver, cedar', tint: '#e5d6c4', petals: 5, copy: 'Deep, polished and quietly powerful' },
      { id: 'floral-collection', family: 'Floral', label: 'Floral & luminous', sub: 'Rose, jasmine, iris', tint: '#f4d6cc', petals: 12, copy: 'Luminous petals with a soft, radiant trail' },
      { id: 'resinous-collection', family: 'Resinous & Oud', label: 'Dark & rare', sub: 'Oud, incense, smoke', tint: '#dcd8f2', petals: 7, copy: 'Smoky oud and incense, rare and magnetic' }
    ];
    var MOMENT = [
      { id: 'Every day', label: 'Every day', sub: 'Office, errands, brunch', tint: '#d8e9d6', curve: 0.32, phrase: 'every day' },
      { id: 'Nights out', label: 'Nights out', sub: 'Dinner, dancing, late Miami', tint: '#dcd8f2', curve: 0.88, phrase: 'your nights out' },
      { id: 'Signature moments', label: 'Signature moments', sub: 'Dates, weddings, the big yes', tint: '#f5e4bf', curve: 0.6, phrase: 'your signature moments' }
    ];

    /* ---------- helpers ---------- */
    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var money = function (v) { var n = parseFloat(v); return isFinite(n) ? '$' + n.toFixed(2) : ''; };
    var sized = function (src, size) {
      if (!src) return '';
      return String(src).replace(/(\.(?:jpe?g|png|gif|webp|avif))(\?[^#]*)?$/i, function (m, ext, q) { return '_' + size + ext + (q || ''); });
    };
    var rgba = function (hex, a) { var c = U.hexToRgb(hex); return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; };
    var easeOut = function (p) { return 1 - Math.pow(1 - p, 3); };
    /* Bound wrappers: a bare `var raf = window.requestAnimationFrame` throws "Illegal invocation" in strict contexts. */
    var raf = window.requestAnimationFrame ? function (f) { return window.requestAnimationFrame(f); } : function (f) { return setTimeout(f, 16); };
    var caf = window.cancelAnimationFrame ? function (id) { window.cancelAnimationFrame(id); } : function (id) { clearTimeout(id); };

    var optHtml = function (attr, i, o) {
      return '<button type="button" class="sa2-finder__opt" ' + attr + '="' + i + '" style="--tint:' + o.tint + '">' +
        '<span class="sa2-finder__opt-l">' + esc(o.label) + '</span><span class="sa2-finder__opt-s">' + esc(o.sub) + '</span></button>';
    };
    var stepHead = function (n, kicker, title) {
      return '<div class="sa2-finder__kicker">' + kicker + '</div>' +
        '<h3 class="sa2-finder__h" id="' + uid + '-h' + n + '" data-f-h tabindex="-1">' + title + '</h3>';
    };
    var backBtn = '<button type="button" class="sa2-finder__back" data-f-back><span aria-hidden="true">←</span> Back</button>';

    /* ---------- markup ---------- */
    try {
      overlay.innerHTML =
        '<div class="sa2-finder__card" data-f-card>' +
          '<button type="button" class="sa2-finder__close" data-f-close aria-label="Close finder"><span aria-hidden="true">×</span></button>' +
          '<div class="sa2-finder__strip" data-f-strip aria-hidden="true"><i></i><i></i><i></i></div>' +
          '<div class="sa2-finder__deck" data-f-deck>' +
            '<div class="sa2-finder__step is-active" data-f-step="0" role="group" aria-labelledby="' + uid + '-h0">' +
              stepHead(0, 'Step 1 of 3', 'Who is this scent for?') +
              '<div class="sa2-finder__opts sa2-finder__opts--who">' + WHO.map(function (o, i) { return optHtml('data-f-who', i, o); }).join('') + '</div>' +
              '<div class="sa2-finder__or"><span>…or describe it</span></div>' +
              '<div class="sa2-finder__search">' +
                '<label class="sa2-finder__sr" for="' + uid + '-q">Describe your scent</label>' +
                '<span class="sa2-finder__search-ico" aria-hidden="true">✦</span>' +
                '<input id="' + uid + '-q" class="sa2-finder__input" data-f-q type="search" placeholder="vanilla, oud, a night in Miami…" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="search">' +
                '<div class="sa2-finder__hits" data-f-hits aria-live="polite" hidden></div>' +
              '</div>' +
            '</div>' +
            '<div class="sa2-finder__step" data-f-step="1" role="group" aria-labelledby="' + uid + '-h1">' +
              stepHead(1, 'Step 2 of 3', 'Which mood pulls you in?') +
              '<div class="sa2-finder__opts sa2-finder__opts--mood">' + MOOD.map(function (o, i) { return optHtml('data-f-mood', i, o); }).join('') + '</div>' +
              backBtn +
            '</div>' +
            '<div class="sa2-finder__step" data-f-step="2" role="group" aria-labelledby="' + uid + '-h2">' +
              stepHead(2, 'Step 3 of 3', 'When will you wear it?') +
              '<div class="sa2-finder__opts sa2-finder__opts--moment">' + MOMENT.map(function (o, i) { return optHtml('data-f-moment', i, o); }).join('') + '</div>' +
              backBtn +
            '</div>' +
            '<div class="sa2-finder__step sa2-finder__result" data-f-step="3" role="group" aria-labelledby="' + uid + '-h3">' +
              '<div class="sa2-finder__kicker">Your scent signature</div>' +
              '<h3 class="sa2-finder__h" id="' + uid + '-h3" data-f-h data-f-title tabindex="-1"></h3>' +
              '<p class="sa2-finder__copy" data-f-copy></p>' +
              '<div class="sa2-finder__dna" data-f-dnawrap>' +
                '<canvas class="sa2-finder__canvas" data-f-dna width="320" height="320" role="img" aria-label="Your scent DNA"></canvas>' +
                '<div class="sa2-finder__dna-cap">Scent DNA <span data-f-code></span></div>' +
              '</div>' +
              '<div class="sa2-finder__products" data-f-products></div>' +
              '<div class="sa2-finder__actions">' +
                '<a class="sa2-finder__btn sa2-finder__btn--dark" data-f-opencol href="' + root + 'collections/all">Open my collection <span aria-hidden="true">→</span></a>' +
                '<button type="button" class="sa2-finder__btn" data-f-share>Share my signature <span aria-hidden="true">✦</span></button>' +
                '<button type="button" class="sa2-finder__btn sa2-finder__btn--ghost" data-f-restart>Start over</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="sa2-finder__toast" data-f-toast role="status" aria-live="polite"></div>' +
        '</div>';
    } catch (e) { return api; }

    var $ = function (sel, el) { return (el || overlay).querySelector(sel); };
    var card = $('[data-f-card]'), deck = $('[data-f-deck]'), strip = $('[data-f-strip]');
    var closeBtn = $('[data-f-close]'), input = $('[data-f-q]'), hits = $('[data-f-hits]');
    var titleEl = $('[data-f-title]'), copyEl = $('[data-f-copy]'), dnaWrap = $('[data-f-dnawrap]'), dna = $('[data-f-dna]');
    var codeEl = $('[data-f-code]'), productsEl = $('[data-f-products]'), openCol = $('[data-f-opencol]'), toast = $('[data-f-toast]');
    var steps = Array.prototype.slice.call(overlay.querySelectorAll('[data-f-step]'));
    var segs = strip ? Array.prototype.slice.call(strip.children) : [];
    if (!card || !deck || steps.length < 4) return api;

    /* ---------- state ---------- */
    var isOpen = false, cur = 0, ans = {}, openerEl = null, prevOverflow = '';
    var hT = 0, hideT = 0, toastT = 0, qT = 0, ctrl = null, resToken = 0, paused = false;
    var dnaRaf = 0, dnaPlan = null, dnaCtx = null, burstRaf = 0, tiltRaf = 0;
    var cache = {};
    var tilt = { x: 0, y: 0, tx: 0, ty: 0, hover: false, rect: null };

    /* ---------- open / close ---------- */
    function focusables() {
      return Array.prototype.slice.call(card.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function onKey(e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !card.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !card.contains(a))) { e.preventDefault(); first.focus(); }
    }
    function safeFocus(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} } }

    function open(opener) {
      if (isOpen) return; isOpen = true;
      openerEl = opener && opener.focus ? opener : document.activeElement;
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      reset();
      clearTimeout(hideT);
      overlay.hidden = false;
      void overlay.offsetWidth; // let display:none → flex settle so the card transition plays
      overlay.classList.add('is-open');
      section.classList.add('is-finder');
      ST.finderOpen = true;
      document.addEventListener('keydown', onKey, true);
      try { overlay.scrollTop = 0; } catch (e) {}
      U.emit('finder', { open: true });
      setTimeout(function () { if (isOpen) safeFocus($('[data-f-who]')); }, U.reduce ? 0 : 120);
    }
    function close() {
      if (!isOpen) return; isOpen = false;
      overlay.classList.remove('is-open');
      section.classList.remove('is-finder');
      ST.finderOpen = false;
      document.documentElement.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey, true);
      stopLoops();
      clearTimeout(hideT);
      /* 480ms ≥ the card's .45s opacity transition, so the exit fade is not cut off */
      hideT = setTimeout(function () { if (!isOpen) overlay.hidden = true; }, U.reduce ? 0 : 480);
      U.emit('finder', { open: false });
      safeFocus(openerEl); openerEl = null;
    }

    /* ---------- steps ---------- */
    function goStep(n, back) {
      var from = steps[cur], to = steps[n];
      if (!to || n === cur) return;
      var h0 = deck.offsetHeight;
      deck.classList.toggle('is-back', !!back);
      if (from) from.classList.remove('is-active');
      to.classList.add('is-active');
      if (from && !U.reduce) {
        var h1 = to.offsetHeight;
        from.classList.add('is-leaving');
        var leaving = from;
        setTimeout(function () { leaving.classList.remove('is-leaving'); }, 480);
        deck.style.height = h0 + 'px';
        void deck.offsetHeight;
        deck.style.height = h1 + 'px';
        clearTimeout(hT); hT = setTimeout(function () { deck.style.height = ''; }, 500);
      }
      cur = n;
      segs.forEach(function (s, i) { s.classList.toggle('is-now', i === n); });
      try { overlay.scrollTo({ top: 0, behavior: U.reduce ? 'auto' : 'smooth' }); } catch (e) { overlay.scrollTop = 0; }
      setTimeout(function () { if (isOpen && cur === n) safeFocus(to.querySelector('[data-f-h]')); }, 60);
    }

    /* Scent ledger: puff of the answer's tint flies into its progress segment, which takes the colour. */
    function ledger(btn, idx, tint) {
      var seg = segs[idx]; if (!seg) return;
      seg.style.setProperty('--tint', tint);
      card.style.setProperty('--t' + (idx + 1), tint);
      if (U.reduce || !btn) { seg.classList.add('is-done'); return; }
      try {
        var cr = card.getBoundingClientRect(), br = btn.getBoundingClientRect(), sr = seg.getBoundingClientRect();
        var x = br.left - cr.left + br.width / 2, y = br.top - cr.top + br.height / 2;
        var puff = document.createElement('span');
        puff.className = 'sa2-finder__puff';
        puff.style.setProperty('--tint', tint);
        puff.style.left = x + 'px'; puff.style.top = y + 'px';
        puff.style.setProperty('--dx', (sr.left - cr.left + sr.width / 2 - x) + 'px');
        puff.style.setProperty('--dy', (sr.top - cr.top + sr.height / 2 - y) + 'px');
        card.appendChild(puff);
        var done = function () { if (puff.parentNode) puff.parentNode.removeChild(puff); };
        puff.addEventListener('animationend', done);
        setTimeout(done, 900);
        setTimeout(function () { seg.classList.add('is-done'); }, 420);
      } catch (e) { seg.classList.add('is-done'); }
    }

    function clearAnswers() {
      ans = {}; resToken++;
      stopLoops();
      card.classList.remove('is-result');
      ['--t1', '--t2', '--t3'].forEach(function (v) { card.style.removeProperty(v); });
      segs.forEach(function (s) { s.classList.remove('is-done', 'is-now'); s.style.removeProperty('--tint'); });
      Array.prototype.forEach.call(overlay.querySelectorAll('.is-picked'), function (el) { el.classList.remove('is-picked'); });
      if (dnaWrap) dnaWrap.classList.remove('is-alive');
      if (dna) dna.style.transform = '';
      if (productsEl) productsEl.innerHTML = '';
      if (segs[0]) segs[0].classList.add('is-now');
    }
    function reset() {
      clearAnswers();
      if (input) input.value = '';
      renderHits(null);
      if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === 0); s.classList.remove('is-leaving'); });
      deck.classList.remove('is-back'); deck.style.height = '';
      cur = 0;
    }

    function pickOpt(btn, idx, tint, next) {
      Array.prototype.forEach.call(btn.parentNode.children, function (el) { el.classList.remove('is-picked'); });
      btn.classList.add('is-picked');
      if (U.isTouch) U.haptic(6);
      ledger(btn, idx, tint);
      setTimeout(next, U.reduce ? 0 : 170);
    }

    /* ---------- predictive search ---------- */
    function renderHits(list, q) {
      if (!hits) return;
      hits.classList.remove('is-busy');
      if (!list) { hits.innerHTML = ''; hits.hidden = true; return; }
      hits.hidden = false;
      if (!list.length) { hits.innerHTML = '<div class="sa2-finder__empty">No match yet — try another note, or press Enter to search everything.</div>'; return; }
      hits.innerHTML = list.map(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var href = p.handle ? root + 'products/' + p.handle : (p.url || '#');
        var meta = [p.vendor, money(p.price)].filter(Boolean).join(' · ');
        return '<a class="sa2-finder__hit" href="' + esc(href) + '">' +
          '<span class="sa2-finder__hit-img">' + (img ? '<img src="' + esc(sized(img, '200x')) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="sa2-finder__hit-txt"><span class="sa2-finder__hit-t">' + esc(p.title) + '</span><span class="sa2-finder__hit-m">' + esc(meta) + '</span></span>' +
          '<span class="sa2-finder__hit-arrow" aria-hidden="true">→</span></a>';
      }).join('') + '<a class="sa2-finder__hit sa2-finder__hit--all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product">See every match for “' + esc(q) + '” <span aria-hidden="true">→</span></a>';
    }
    function search(q) {
      if (!window.fetch) return;
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = window.AbortController ? new AbortController() : null;
      var my = ctrl;
      if (hits) { hits.hidden = false; hits.classList.add('is-busy'); }
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
      fetch(url, { credentials: 'same-origin', signal: my ? my.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (my !== ctrl) return;
          var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          renderHits(list, q);
        })
        .catch(function (err) { if (err && err.name === 'AbortError') return; if (my === ctrl) renderHits([], q); });
    }
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(qT);
        var q = input.value.trim();
        if (q.length < 2) {
          /* abort any in-flight request so a stale response cannot re-open the hits list */
          if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
          renderHits(null); return;
        }
        qT = setTimeout(function () { search(q); }, 250);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || e.isComposing) return;
        var q = input.value.trim(); if (!q) return;
        e.preventDefault();
        location.href = root + 'search?q=' + encodeURIComponent(q) + '&type=product';
      });
    }

    /* ---------- SCENT DNA (deterministic generative artwork) ---------- */
    function planDna(who, mood, mo) {
      var day = Math.floor(Date.now() / 864e5);
      var seed = (U.hash(mood.family + '|' + who.id + '|' + mo.id) + day * 7919) >>> 0;
      var rnd = U.prng(seed);
      var R = 150, items = [], i;
      var ringN = (who.rings || 6) + (rnd() < 0.4 ? 1 : 0);
      var ringR = [];
      for (i = 0; i < ringN; i++) {
        var r = R * (0.3 + 0.7 * (i + 1) / ringN) - 3;
        ringR.push(r);
        items.push({ k: 'ring', r: r, w: i % 2 ? 0.7 : 1.15, a: 0.3 + 0.45 * rnd(), dash: rnd() < 0.45 ? 0 : 2 + Math.floor(rnd() * 5), ph: rnd() * 6.283, s: 0.04 + 0.5 * i / ringN, d: 0.5 });
      }
      var n = mood.petals, c = mo.curve, rot = rnd() * 6.283;
      var L1 = R * (0.6 + 0.2 * rnd()), w1 = L1 * (0.14 + 0.16 * c);
      for (i = 0; i < n; i++) items.push({ k: 'petal', a: rot + i * 6.283 / n, L: L1, w: w1, c: c, fill: mood.tint, fa: 0.42, s: 0.18 + 0.42 * i / n, d: 0.45 });
      for (i = 0; i < n; i++) items.push({ k: 'petal', a: rot + (i + 0.5) * 6.283 / n, L: L1 * 0.52, w: w1 * 0.72, c: -c * 0.8, fill: who.tint, fa: 0.58, s: 0.34 + 0.36 * i / n, d: 0.4 });
      for (var j = 0; j < ringN; j += 2) {
        for (i = 0; i < n; i++) {
          var a = rot + (i + (j % 4 ? 0.5 : 0)) * 6.283 / n;
          items.push({ k: 'dot', x: Math.cos(a) * ringR[j], y: Math.sin(a) * ringR[j], r: 1.1 + rnd() * 1.3, col: rnd() < 0.7 ? GOLD : DEEP, s: 0.55 + 0.4 * rnd(), d: 0.15 });
        }
      }
      items.push({ k: 'core', s: 0, d: 0.35 });
      /* span = latest (start + duration) among items; the reveal timeline is stretched by it so every
         petal/dot is fully drawn at t = 1 (petals ended at s+d ≈ 1.05, dots at ≈ 1.1 otherwise). */
      var span = 1;
      for (i = 0; i < items.length; i++) span = Math.max(span, items[i].s + items[i].d);
      var code = ('000' + (seed % 4096).toString(16)).slice(-3).toUpperCase() + '·' + ('0' + (day % 97)).slice(-2);
      return { seed: seed, items: items, tint: mood.tint, code: code, span: span };
    }
    function drawDna(ctx, plan, t) {
      var d = U.dpr;
      ctx.setTransform(d, 0, 0, d, 0, 0);
      ctx.clearRect(0, 0, 320, 320);
      var g = ctx.createRadialGradient(160, 160, 8, 160, 160, 168);
      g.addColorStop(0, rgba(plan.tint, 0.95 * t)); g.addColorStop(0.65, rgba(plan.tint, 0.32 * t)); g.addColorStop(1, rgba(plan.tint, 0));
      ctx.fillStyle = g; ctx.fillRect(0, 0, 320, 320);
      ctx.translate(160, 160);
      ctx.lineCap = 'round';
      var items = plan.items, T = t * (plan.span || 1);
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var p = U.clamp((T - it.s) / it.d, 0, 1);
        if (p <= 0) continue;
        p = easeOut(p);
        if (it.k === 'ring') {
          ctx.beginPath();
          ctx.setLineDash(it.dash ? [it.dash, it.dash * 1.7] : []);
          ctx.arc(0, 0, it.r, it.ph, it.ph + 6.2832 * p);
          ctx.strokeStyle = rgba(GOLD, it.a); ctx.lineWidth = it.w; ctx.stroke();
          ctx.setLineDash([]);
        } else if (it.k === 'petal') {
          ctx.save(); ctx.rotate(it.a); ctx.scale(p, p);
          ctx.beginPath(); ctx.moveTo(0, 0);
          ctx.quadraticCurveTo(it.L * 0.45, it.w * (1 + it.c), it.L, it.c * it.L * 0.4);
          ctx.quadraticCurveTo(it.L * 0.55, -it.w * (1 - it.c * 0.5), 0, 0);
          ctx.closePath();
          ctx.fillStyle = rgba(it.fill, it.fa * p); ctx.fill();
          ctx.strokeStyle = rgba(GOLD, 0.6 * p); ctx.lineWidth = 0.9; ctx.stroke();
          ctx.restore();
        } else if (it.k === 'dot') {
          ctx.beginPath(); ctx.arc(it.x, it.y, it.r * p, 0, 6.2832);
          ctx.fillStyle = it.col; ctx.fill();
        } else {
          var cg = ctx.createRadialGradient(0, 0, 0, 0, 0, 18 * p);
          cg.addColorStop(0, '#fff'); cg.addColorStop(0.45, GOLD); cg.addColorStop(1, rgba(GOLD, 0));
          ctx.beginPath(); ctx.arc(0, 0, 18 * p, 0, 6.2832); ctx.fillStyle = cg; ctx.fill();
          ctx.beginPath(); ctx.arc(0, 0, 24 * p, 0, 6.2832); ctx.strokeStyle = rgba(DEEP, 0.7 * p); ctx.lineWidth = 0.8; ctx.stroke();
        }
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    }
    function revealDna(plan) {
      if (!dna) return;
      try {
        if (!dnaCtx) dnaCtx = dna.getContext('2d');
        if (!dnaCtx) return;
        var d = U.dpr, px = Math.round(320 * d);
        if (dna.width !== px || dna.height !== px) { dna.width = px; dna.height = px; }
        caf(dnaRaf); dnaPlan = plan;
        if (U.reduce) { drawDna(dnaCtx, plan, 1); return; }
        var t0 = performance.now();
        var step = function (now) {
          if (!isOpen || dnaPlan !== plan) return;
          var t = Math.min(1, (now - t0) / 1200);
          drawDna(dnaCtx, plan, t);
          if (t < 1 && !paused) dnaRaf = raf(step);
          else { drawDna(dnaCtx, plan, 1); if (dnaWrap) dnaWrap.classList.add('is-alive'); }
        };
        dnaRaf = raf(step);
      } catch (e) {}
    }

    /* Gold burst on the result (short-lived canvas around the artwork) */
    function burst(tint) {
      if (U.reduce || !dnaWrap) return;
      try {
        var cv = document.createElement('canvas');
        cv.className = 'sa2-finder__burst';
        var cr = card.getBoundingClientRect(), dr = dnaWrap.getBoundingClientRect();
        var size = Math.min(640, Math.max(320, cr.width)), half = size / 2;
        var cx = dr.left - cr.left + dr.width / 2, cy = dr.top - cr.top + dr.height / 2;
        cv.style.left = (cx - half) + 'px'; cv.style.top = (cy - half) + 'px';
        cv.style.width = size + 'px'; cv.style.height = size + 'px';
        var d = U.dpr; cv.width = Math.round(size * d); cv.height = Math.round(size * d);
        var ctx = cv.getContext('2d'); if (!ctx) return;
        card.appendChild(cv);
        var ps = [], N = 130, i;
        for (i = 0; i < N; i++) {
          var a = Math.random() * 6.283, sp = 1.5 + Math.random() * 6.5, r = Math.random();
          ps.push({ x: half, y: half, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 1.5, r: 0.8 + Math.random() * 2, c: r < 0.55 ? GOLD : (r < 0.8 ? tint : DEEP), l: 0.75 + Math.random() * 0.5, star: Math.random() < 0.12 });
        }
        var t0 = performance.now(), last = t0;
        var tick = function (now) {
          var dt = Math.min(2, (now - last) / 16.7); last = now;
          var age = (now - t0) / 1000, alive = 0;
          ctx.setTransform(d, 0, 0, d, 0, 0); ctx.clearRect(0, 0, size, size);
          for (var k = 0; k < N; k++) {
            var q = ps[k], life = 1 - age / q.l; if (life <= 0) continue; alive++;
            q.vy += 0.07 * dt; q.vx *= 0.985; q.vy *= 0.985; q.x += q.vx * dt; q.y += q.vy * dt;
            ctx.globalAlpha = Math.min(1, life * 1.5); ctx.fillStyle = q.c;
            if (q.star) {
              ctx.strokeStyle = q.c; ctx.lineWidth = 1; var s = q.r * 2.2 * life;
              ctx.beginPath(); ctx.moveTo(q.x - s, q.y); ctx.lineTo(q.x + s, q.y); ctx.moveTo(q.x, q.y - s); ctx.lineTo(q.x, q.y + s); ctx.stroke();
            } else { ctx.beginPath(); ctx.arc(q.x, q.y, q.r * (0.4 + 0.6 * life), 0, 6.2832); ctx.fill(); }
          }
          ctx.globalAlpha = 1;
          if (alive && isOpen && !paused) burstRaf = raf(tick); else if (cv.parentNode) cv.parentNode.removeChild(cv);
        };
        burstRaf = raf(tick);
      } catch (e) {}
    }

    /* Desktop: the artwork leans toward the mouse (rect cached on enter; transform only) */
    function tiltLoop() {
      tilt.x = U.lerp(tilt.x, tilt.tx, 0.12); tilt.y = U.lerp(tilt.y, tilt.ty, 0.12);
      if (dna) dna.style.transform = 'rotateX(' + tilt.x.toFixed(2) + 'deg) rotateY(' + tilt.y.toFixed(2) + 'deg)';
      var idle = Math.abs(tilt.x - tilt.tx) < 0.03 && Math.abs(tilt.y - tilt.ty) < 0.03;
      if (!idle && isOpen && !paused) tiltRaf = raf(tiltLoop); else tiltRaf = 0;
    }
    if (dnaWrap && !U.isTouch) {
      dnaWrap.addEventListener('pointerenter', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        tilt.hover = true; tilt.rect = dnaWrap.getBoundingClientRect();
      });
      dnaWrap.addEventListener('pointermove', function (e) {
        if (U.reduce || !tilt.hover || !tilt.rect) return;
        var r = tilt.rect;
        tilt.ty = ((e.clientX - r.left) / r.width - 0.5) * 16;
        tilt.tx = -((e.clientY - r.top) / r.height - 0.5) * 16;
        if (!tiltRaf) tiltRaf = raf(tiltLoop);
      }, { passive: true });
      dnaWrap.addEventListener('pointerleave', function () {
        tilt.hover = false; tilt.tx = tilt.ty = 0;
        if (!tiltRaf) tiltRaf = raf(tiltLoop);
      });
    }

    function stopLoops() {
      caf(dnaRaf); dnaRaf = 0; dnaPlan = null;
      caf(burstRaf); burstRaf = 0;
      caf(tiltRaf); tiltRaf = 0; tilt.x = tilt.y = tilt.tx = tilt.ty = 0;
      Array.prototype.forEach.call(card.querySelectorAll('.sa2-finder__burst,.sa2-finder__puff'), function (el) { el.parentNode.removeChild(el); });
    }

    /* ---------- products ---------- */
    function loadProducts(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);
      if (!window.fetch) return Promise.reject(new Error('no fetch'));
      return fetch(root + 'collections/' + handle + '/products.json?limit=60', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { var list = (j && j.products) || []; cache[handle] = list; return list; });
    }
    function normalize(p) {
      var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(isFinite);
      var img = p.images && p.images[0] && (p.images[0].src || p.images[0].url);
      return { title: p.title || '', handle: p.handle || '', url: root + 'products/' + (p.handle || ''), price: prices.length ? money(Math.min.apply(null, prices)) : '', image: sized(img, '400x') };
    }
    function pick(list, gender, rnd) {
      var withImg = list.filter(function (p) { return p && p.images && p.images.length; });
      var g = String(gender).toLowerCase();
      var match = withImg.filter(function (p) { return String(p.product_type || '').trim().toLowerCase() === g; });
      var out;
      if (match.length >= 4) {
        out = match.slice(0, 12);
        for (var i = out.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var t = out[i]; out[i] = out[j]; out[j] = t; }
        out = out.slice(0, 4);
      } else {
        out = match.concat(withImg.filter(function (p) { return match.indexOf(p) < 0; })).slice(0, 4);
      }
      return out.map(normalize);
    }
    function productCard(p) {
      return '<a class="sa2-finder__prod" href="' + esc(p.url) + '">' +
        '<span class="sa2-finder__prod-img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
        '<span class="sa2-finder__prod-t">' + esc(p.title) + '</span>' +
        '<span class="sa2-finder__prod-p">' + esc(p.price) + '</span></a>';
    }
    var skeleton = (function () {
      var s = '';
      for (var i = 0; i < 4; i++) s += '<span class="sa2-finder__prod is-skel" aria-hidden="true"><span class="sa2-finder__prod-img"></span><span class="sa2-finder__prod-t"></span><span class="sa2-finder__prod-p"></span></span>';
      return s;
    })();

    /* ---------- result ---------- */
    function showResult() {
      var who = ans.who, mood = ans.mood, mo = ans.moment;
      if (!who || !mood || !mo) return;
      var token = ++resToken;
      var gender = who.id, url = root + 'collections/' + mood.id + '?filter.p.product_type=' + encodeURIComponent(gender);
      if (titleEl) titleEl.textContent = mood.family + ' · ' + gender;
      if (copyEl) copyEl.textContent = mood.copy + ' — tuned for ' + mo.phrase + '.';
      if (openCol) openCol.href = url;
      var plan = null;
      try { plan = planDna(who, mood, mo); } catch (e) {}
      if (codeEl) codeEl.textContent = plan ? '№ ' + plan.code : '';
      if (dna) dna.setAttribute('aria-label', 'Your scent DNA: ' + mood.family + ' · ' + gender + ', for ' + mo.phrase);
      if (productsEl) productsEl.innerHTML = skeleton;
      card.classList.add('is-result');
      goStep(3);
      if (plan) revealDna(plan);
      /* 470ms: after the step's .45s flip-in, so the artwork rect read by burst() is its settled position */
      setTimeout(function () { if (isOpen && token === resToken) burst(mood.tint); }, U.reduce ? 0 : 470);

      var finish = function (products) {
        if (token !== resToken || !isOpen) return;
        if (productsEl) {
          productsEl.innerHTML = products.length ? products.map(productCard).join('') :
            '<div class="sa2-finder__empty">Your matches are waiting in the collection — open it below.</div>';
        }
        U.emit('result', { family: mood.family, gender: gender, moment: mo.id, url: url, products: products });
      };
      loadProducts(mood.id)
        .then(function (list) { finish(pick(list, gender, U.prng(plan ? plan.seed : U.hash(gender)))); })
        .catch(function () { finish([]); });
    }

    /* ---------- share ---------- */
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg; toast.classList.add('is-show');
      clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('is-show'); }, 1700);
    }
    function copyText(txt) {
      var ok = function () { showToast('Copied'); }, fail = function () { showToast('Couldn’t copy'); };
      var legacy = function () {
        try {
          var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
          card.appendChild(ta); ta.select(); ta.setSelectionRange(0, txt.length);
          var done = document.execCommand && document.execCommand('copy');
          card.removeChild(ta); done ? ok() : fail();
        } catch (e) { fail(); }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, legacy); else legacy();
    }
    function share() {
      var mood = ans.mood, who = ans.who; if (!mood || !who) return;
      var data = { title: 'My Saduluxury scent signature', text: mood.family + ' · ' + who.id + ' — find yours', url: location.origin + '/#atelier' };
      var fallback = function () { copyText(data.text + ' ' + data.url); };
      if (navigator.share) {
        try { navigator.share(data).then(function () { if (U.isTouch) U.haptic(6); },function (err) { if (!err || err.name !== 'AbortError') fallback(); }); return; } catch (e) {}
      }
      fallback();
    }

    /* ---------- wiring ---------- */
    deck.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-f-who],[data-f-mood],[data-f-moment],[data-f-back],[data-f-restart],[data-f-share]') : null;
      if (!t || !deck.contains(t)) return;
      var v;
      if (t.hasAttribute('data-f-who')) { v = WHO[+t.getAttribute('data-f-who')]; if (!v) return; ans.who = v; pickOpt(t, 0, v.tint, function () { goStep(1); }); }
      else if (t.hasAttribute('data-f-mood')) { v = MOOD[+t.getAttribute('data-f-mood')]; if (!v) return; ans.mood = v; pickOpt(t, 1, v.tint, function () { goStep(2); }); }
      else if (t.hasAttribute('data-f-moment')) { v = MOMENT[+t.getAttribute('data-f-moment')]; if (!v) return; ans.moment = v; pickOpt(t, 2, v.tint, function () { showResult(); }); }
      else if (t.hasAttribute('data-f-back')) {
        var prev = Math.max(0, cur - 1);
        if (segs[cur]) { segs[cur].classList.remove('is-done'); segs[cur].style.removeProperty('--tint'); }
        if (segs[prev]) { segs[prev].classList.remove('is-done'); segs[prev].style.removeProperty('--tint'); }
        card.style.removeProperty('--t' + (prev + 1));
        if (prev === 0) ans.who = null; else if (prev === 1) ans.mood = null;
        goStep(prev, true);
      }
      else if (t.hasAttribute('data-f-restart')) { clearAnswers(); goStep(0, true); }
      else if (t.hasAttribute('data-f-share')) share();
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });

    var downOnBackdrop = false;
    var onBackdropDown = function (e) { downOnBackdrop = e.target === overlay; };
    var onBackdropClick = function (e) { if (e.target === overlay && downOnBackdrop) close(); downOnBackdrop = false; };
    overlay.addEventListener('pointerdown', onBackdropDown, { passive: true });
    overlay.addEventListener('click', onBackdropClick);

    var openers = Array.prototype.slice.call(section.querySelectorAll('[data-sa2-open]'));
    var onOpenClick = function (e) { if (e && e.preventDefault) e.preventDefault(); open(e && e.currentTarget); };
    openers.forEach(function (b) { b.addEventListener('click', onOpenClick); });

    /* Deep link: /#find-my-scent (and /#atelier — the URL share() hands out) scrolls here and opens the finder */
    var linkT = 0;
    try {
      if (/^#(find-my-scent|scent-finder|atelier)$/i.test(location.hash)) linkT = setTimeout(function () {
        try { section.scrollIntoView({ block: 'start' }); } catch (e) {}
        open(openers[0]);
      }, 400);
    } catch (e) {}

    /* ---------- API ---------- */
    api.open = function () { open(openers[0]); };
    api.close = close;
    api.isOpen = function () { return isOpen; };
    api.pause = function () {
      paused = true; caf(dnaRaf); caf(burstRaf); caf(tiltRaf); dnaRaf = burstRaf = tiltRaf = 0;
      /* a burst cannot resume mid-flight; drop its canvas instead of leaving a frozen frame on screen */
      Array.prototype.forEach.call(card.querySelectorAll('.sa2-finder__burst'), function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    };
    api.resume = function () {
      paused = false;
      if (!isOpen) return;
      if (dnaPlan && dnaCtx) { try { drawDna(dnaCtx, dnaPlan, 1); if (dnaWrap) dnaWrap.classList.add('is-alive'); } catch (e) {} }
      if (tilt.hover && !tiltRaf) tiltRaf = raf(tiltLoop);
    };
    api.resize = function () {
      tilt.rect = null; tilt.hover = false; tilt.tx = tilt.ty = 0;
      /* run the lerp back to rest so the artwork is not left tilted after a resize */
      if (isOpen && !paused && !tiltRaf && (tilt.x || tilt.y)) tiltRaf = raf(tiltLoop);
    };
    api.destroy = function () {
      close();
      clearTimeout(hideT); clearTimeout(qT); clearTimeout(hT); clearTimeout(toastT); clearTimeout(linkT);
      if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
      openers.forEach(function (b) { b.removeEventListener('click', onOpenClick); });
      overlay.removeEventListener('pointerdown', onBackdropDown);
      overlay.removeEventListener('click', onBackdropClick);
      document.removeEventListener('keydown', onKey, true);
      caf(dnaRaf); caf(burstRaf); caf(tiltRaf); dnaRaf = burstRaf = tiltRaf = 0;
      overlay.hidden = true; overlay.innerHTML = '';
      api.open = api.close = api.pause = api.resume = api.resize = api.destroy = noop;
    };
    return api;
  });
})();


/* ===== sa2-fx.js ===== */
/* SADU Atelier 2.0 — fx (booted last): dew-drop cursor, magnetic buttons, headline word cascade,
   morphing word, text scramble on panel change, time-aware greeting (solar ornament),
   liquid-drop tap ripples, idle nudge. Transform/opacity only; no per-frame layout reads. */
(function () {
  if (!window.SA2 || typeof window.SA2.register !== 'function') return;
  window.SA2.register('fx', function (section) {
    var S = window.SA2, U = S.util, P = S.pointer, ST = S.state;
    var reduce = !!U.reduce;
    var DESK = !!(U.isDesk() && !U.isTouch);
    var alive = true, paused = false, seen = false;
    var offs = [], timers = [];
    var warn = function (e) { try { console.warn('[SA2 fx]', e); } catch (x) {} };
    var $ = function (sel, root) { try { return (root || section).querySelector(sel); } catch (e) { return null; } };
    var $$ = function (sel, root) { try { return Array.prototype.slice.call((root || section).querySelectorAll(sel)); } catch (e) { return []; } };
    var mk = function (tag, cls) { var el = document.createElement(tag); if (cls) el.className = cls; return el; };
    var listen = function (el, ev, fn, opt) { if (!el) return; el.addEventListener(ev, fn, opt); offs.push(function () { el.removeEventListener(ev, fn, opt); }); };
    /* cancellable timers (cleared on halt/destroy) */
    var later = function (fn, ms) {
      var id = setTimeout(function () {
        var i = timers.indexOf(id); if (i > -1) timers.splice(i, 1);
        if (!alive) return; try { fn(); } catch (e) { warn(e); }
      }, ms);
      timers.push(id); return id;
    };
    var cancel = function (id) { if (id == null) return; clearTimeout(id); var i = timers.indexOf(id); if (i > -1) timers.splice(i, 1); };
    var clearTimers = function () { timers.forEach(clearTimeout); timers.length = 0; };
    var live = function () { return alive && !paused && ST.visible && !ST.finderOpen && document.visibilityState !== 'hidden'; };

    /* ---------- 1. Time-aware greeting + solar ornament (sun/moon on an arc at the local hour) ---------- */
    var greet = $('[data-sa2-greet]');
    var greetOrig = greet ? greet.innerHTML : '';
    var greetOn = section.getAttribute('data-greet') === '1';
    var greetKey = '';
    function sunGlyph(hh) {
      var NS = 'http://www.w3.org/2000/svg', uid = 'sa2sun-' + (section.id || 'x');
      var el = function (t, attrs) { var n = document.createElementNS(NS, t); for (var k in attrs) n.setAttribute(k, attrs[k]); return n; };
      var svg = el('svg', { 'class': 'sa2-sun', viewBox: '0 0 24 14', 'aria-hidden': 'true' });
      svg.appendChild(el('path', { 'class': 'sa2-sun__arc', d: 'M2.5 12.5A9.5 9.5 0 0 1 21.5 12.5' }));
      if (hh >= 6 && hh < 19) {
        var a = Math.PI * (hh - 6) / 13; /* sunrise (left) -> noon (top) -> dusk (right) */
        svg.appendChild(el('circle', { 'class': 'sa2-sun__orb', cx: (12 - 9.5 * Math.cos(a)).toFixed(2), cy: (12.5 - 9.5 * Math.sin(a)).toFixed(2), r: '1.9' }));
      } else {
        var mask = el('mask', { id: uid });
        mask.appendChild(el('circle', { cx: '12', cy: '5', r: '2.4', fill: '#fff' }));
        mask.appendChild(el('circle', { cx: '13.4', cy: '4.1', r: '2.1', fill: '#000' }));
        svg.appendChild(mask);
        svg.appendChild(el('circle', { 'class': 'sa2-sun__orb sa2-sun__orb--moon', cx: '12', cy: '5', r: '2.4', mask: 'url(#' + uid + ')' }));
      }
      return svg;
    }
    function setGreeting() {
      if (!greet || !greetOn) return;
      try {
        var d = new Date(), h = d.getHours(), hh = h + d.getMinutes() / 60;
        var word = h < 12 ? 'morning' : h < 18 ? 'afternoon' : 'evening';
        var key = word + ':' + Math.floor(hh * 4); /* re-render at most every 15 min */
        if (key === greetKey) return;
        greetKey = key;
        greet.textContent = '';
        greet.appendChild(sunGlyph(hh));
        greet.appendChild(document.createTextNode('Good ' + word + ' · The atelier is open'));
      } catch (e) { warn(e); }
    }

    /* ---------- 2. Headline: words rise in (clip-path) on first view ---------- */
    var head = $('[data-sa2-head]'), pre = $('[data-sa2-pre]');
    var preOrig = pre ? pre.innerHTML : '';
    function splitWords() {
      if (!pre) return;
      var text = (pre.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      pre.textContent = '';
      var ws = text.split(' ');
      ws.forEach(function (w, i) {
        var o = mk('span', 'sa2-w'), n = mk('span', 'sa2-w__in');
        o.style.setProperty('--i', i); n.textContent = w; o.appendChild(n); pre.appendChild(o);
        if (i < ws.length - 1) pre.appendChild(document.createTextNode(' '));
      });
    }
    function cascade() { if (seen) return; seen = true; if (head) head.classList.add('is-cascade'); }

    /* ---------- 3. Morphing word: letter-by-letter cascade every 2.6s ---------- */
    var morph = $('[data-sa2-morph]'), morphB = morph ? morph.querySelector('b') : null;
    var morphOrig = morph ? morph.innerHTML : '';
    var words = [], wi = 0, widths = {}, morphTimer = null, pending = null, sr = null, meas = null;
    function setupMorph() {
      if (!morph || !morphB) return;
      words = (morph.getAttribute('data-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      var first = (morphB.textContent || '').trim();
      if (!words.length) words = [first || 'scent'];
      wi = Math.max(0, words.indexOf(first));
      sr = mk('span', 'sa2-vh'); sr.textContent = words[wi];
      morph.insertBefore(sr, morphB);
      morphB.setAttribute('aria-hidden', 'true');
      morphB.textContent = '';
      buildLetters(words[wi], false);
      meas = mk('span', 'sa2-morph__m'); meas.setAttribute('aria-hidden', 'true');
      morph.appendChild(meas);
      measureWords();
      try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (alive) measureWords(); }); } catch (e) {}
    }
    function measureWords() {
      if (!meas) return;
      try {
        words.forEach(function (w) { meas.textContent = w; var ww = meas.getBoundingClientRect().width; if (ww > 0) widths[w] = Math.ceil(ww) + 1; });
        meas.textContent = '';
        var cur = pending || words[wi];
        if (widths[cur]) morph.style.width = widths[cur] + 'px';
      } catch (e) { warn(e); }
    }
    function buildLetters(word, anim) {
      var frag = document.createDocumentFragment(), chars = Array.from(word);
      chars.forEach(function (ch, i) {
        var s = mk('span', 'sa2-l' + (anim ? ' is-pre' : ''));
        s.textContent = ch; s.style.setProperty('--i', i); s.style.setProperty('--d', (i * 30) + 'ms');
        frag.appendChild(s);
      });
      morphB.appendChild(frag);
      if (anim) requestAnimationFrame(function () { requestAnimationFrame(function () { $$('.sa2-l.is-pre', morphB).forEach(function (s) { s.classList.remove('is-pre'); }); }); });
    }
    function finishSwap(anim) {
      if (!pending) return;
      $$('.sa2-l', morphB).forEach(function (s) { if (s.parentNode) s.parentNode.removeChild(s); });
      wi = Math.max(0, words.indexOf(pending));
      if (sr) sr.textContent = words[wi];
      buildLetters(words[wi], anim);
      if (widths[words[wi]]) morph.style.width = widths[words[wi]] + 'px';
      pending = null;
    }
    function nextWord() {
      morphTimer = null;
      if (!live() || !morphB) return;
      if (words.length < 2 || pending) { scheduleMorph(); return; }
      pending = words[(wi + 1) % words.length];
      var old = $$('.sa2-l', morphB);
      old.forEach(function (s, i) { s.style.setProperty('--d', (i * 30) + 'ms'); s.classList.add('is-out'); });
      if (widths[pending]) morph.style.width = widths[pending] + 'px';
      /* wait for the last letter's out-transition (.42s + its stagger) before rebuilding */
      later(function () { finishSwap(true); scheduleMorph(); }, 440 + old.length * 30);
    }
    function scheduleMorph() {
      cancel(morphTimer); morphTimer = null;
      if (!morphB || reduce || words.length < 2 || !live()) return;
      morphTimer = later(nextWord, 2600);
    }

    /* ---------- 4. Text scramble on panel change ---------- */
    var GLYPHS = '·✦◦∙·∙abcdefghijklmnopqrstuvwxyz';
    var scr = { el: null, raf: 0 };
    function scramble(el) {
      if (!el) return;
      var real = el.getAttribute('data-sa2-text');
      if (real == null) { real = el.textContent || ''; el.setAttribute('data-sa2-text', real); }
      if (scr.raf) { cancelAnimationFrame(scr.raf); scr.raf = 0; }
      if (scr.el && scr.el !== el) scr.el.textContent = scr.el.getAttribute('data-sa2-text') || '';
      scr.el = el;
      if (reduce || !live()) { el.textContent = real; return; }
      var chars = Array.from(real), n = chars.length, dur = 520, t0 = performance.now(), lastSwap = -1, out = '';
      var th = chars.map(function (c, i) { return c === ' ' ? -1 : (i / Math.max(1, n - 1)) * 0.68 + Math.random() * 0.22; });
      var frame = function (now) {
        scr.raf = 0;
        if (!alive) return;
        var p = Math.min(1, (now - t0) / dur);
        if (p >= 1) { el.textContent = real; return; }
        var slot = Math.floor((now - t0) / 45); /* glyphs re-roll every 45ms, not every frame */
        if (slot !== lastSwap) {
          lastSwap = slot; out = '';
          for (var i = 0; i < n; i++) out += (th[i] < 0 || p >= th[i]) ? chars[i] : GLYPHS.charAt((Math.random() * GLYPHS.length) | 0);
          el.textContent = out;
        }
        scr.raf = requestAnimationFrame(frame);
      };
      scr.raf = requestAnimationFrame(frame);
    }
    function stopScramble() { if (scr.raf) { cancelAnimationFrame(scr.raf); scr.raf = 0; } if (scr.el) scr.el.textContent = scr.el.getAttribute('data-sa2-text') || scr.el.textContent; }

    /* ---------- 5. Dew-drop cursor (desktop): gold bead that stretches into a comet with speed,
                    settles with a tiny ring when you stop, halo tinted by the front scent ---------- */
    var cur = $('[data-sa2-cursor]'), ringEl = $('[data-sa2-ring]'), cdot = null, chalo = null, cset = null;
    var C = { ready: false, on: false, link: false, grab: false, moving: false, x: 0, y: 0, hx: 0, hy: 0, px: 0, py: 0, st: 1, sz: 1, ang: 0 };
    function setupCursor() {
      if (!cur || C.ready || !DESK) return;
      try {
        cur.textContent = '';
        chalo = mk('span', 'sa2-cursor__halo'); cdot = mk('span', 'sa2-cursor__dot'); cset = mk('span', 'sa2-cursor__settle');
        cur.appendChild(chalo); cur.appendChild(cdot); cur.appendChild(cset);
        cur.classList.add('is-ready');
        C.ready = true;
      } catch (e) { warn(e); }
    }
    function setLink(b) { if (b !== C.link) { C.link = b; if (cur) cur.classList.toggle('is-link', b); } }
    function settle() {
      if (!cset || !cur) return;
      var n = cset.cloneNode(false); n.className = 'sa2-cursor__settle is-go';
      n.style.left = C.x.toFixed(1) + 'px'; n.style.top = C.y.toFixed(1) + 'px';
      cur.replaceChild(n, cset); cset = n;
    }
    function stepCursor() {
      var active = DESK && P.active && !ST.finderOpen;
      if (active !== C.on) {
        C.on = active; cur.classList.toggle('is-on', active);
        if (active) { C.x = C.hx = C.px = P.x; C.y = C.hy = C.py = P.y; C.st = 1; C.moving = false; }
      }
      if (!active) return false;
      var k = reduce ? 1 : 0.3, kh = reduce ? 1 : 0.14;
      C.px = C.x; C.py = C.y;
      C.x += (P.x - C.x) * k; C.y += (P.y - C.y) * k;
      C.hx += (P.x - C.hx) * kh; C.hy += (P.y - C.hy) * kh;
      var vx = C.x - C.px, vy = C.y - C.py, sp = Math.sqrt(vx * vx + vy * vy);
      var grab = section.classList.contains('is-grabbing') || (ringEl && ringEl.classList.contains('is-grabbing')) || (P.down && !C.link);
      if (grab !== C.grab) { C.grab = grab; cur.classList.toggle('is-grab', !!grab); }
      var tSt = (reduce || C.link || grab) ? 1 : 1 + Math.min(1.5, sp * 0.055);
      var tSz = C.link ? 3.4 : grab ? 0.75 : 1;
      C.st += (tSt - C.st) * 0.3; C.sz += (tSz - C.sz) * 0.25;
      if (sp > 0.6) C.ang = Math.atan2(vy, vx);
      var sx = C.st * C.sz, sy = C.sz / Math.sqrt(C.st);
      cdot.style.transform = 'translate3d(' + C.x.toFixed(1) + 'px,' + C.y.toFixed(1) + 'px,0) rotate(' + C.ang.toFixed(3) + 'rad) scale(' + sx.toFixed(3) + ',' + sy.toFixed(3) + ')';
      chalo.style.transform = 'translate3d(' + C.hx.toFixed(1) + 'px,' + C.hy.toFixed(1) + 'px,0)';
      if (sp > 5) C.moving = true;
      else if (C.moving && sp < 0.35) { C.moving = false; if (!C.link && !grab && !reduce) settle(); }
      var rest = Math.abs(P.x - C.hx) < 0.15 && Math.abs(P.y - C.hy) < 0.15 && Math.abs(C.st - 1) < 0.01 && Math.abs(C.sz - tSz) < 0.01;
      return !rest;
    }

    /* ---------- 6. Magnetic buttons (desktop): pull within 80px, max 10px, spring back ---------- */
    var mags = [], magT = 0;
    function setupMag() {
      if (!DESK || reduce || mags.length) return;
      mags = $$('[data-magnetic]').map(function (el) { return { el: el, ok: false, hot: false, x: 0, y: 0, vx: 0, vy: 0, l: 0, t: 0, r: 0, b: 0, cx: 0, cy: 0 }; });
    }
    function measureMags() {
      if (!mags.length) return;
      try {
        var sr = section.getBoundingClientRect();
        mags.forEach(function (m) {
          var r = m.el.getBoundingClientRect();
          if (!r.width || !r.height) { m.ok = false; return; }
          m.l = r.left - sr.left - m.x; m.t = r.top - sr.top - m.y; m.r = m.l + r.width; m.b = m.t + r.height;
          m.cx = (m.l + m.r) / 2; m.cy = (m.t + m.b) / 2; m.ok = true;
        });
      } catch (e) { warn(e); }
      magT = performance.now();
    }
    function stepMag() {
      var busy = false, active = P.active && !ST.finderOpen, now = performance.now();
      if (active && now - magT > 1000) measureMags(); /* one rect pass per second at most, never per frame */
      for (var i = 0; i < mags.length; i++) {
        var m = mags[i], tx = 0, ty = 0;
        if (active && m.ok) {
          var nx = U.clamp(P.x, m.l, m.r), ny = U.clamp(P.y, m.t, m.b);
          var d = Math.sqrt((P.x - nx) * (P.x - nx) + (P.y - ny) * (P.y - ny));
          if (d < 80) {
            var pull = 1 - d / 80, dx = P.x - m.cx, dy = P.y - m.cy, len = Math.sqrt(dx * dx + dy * dy) || 1;
            var mag = Math.min(10, len * 0.12) * pull;
            tx = dx / len * mag; ty = dy / len * mag;
          }
        }
        m.vx += (tx - m.x) * 0.16; m.vy += (ty - m.y) * 0.16; m.vx *= 0.72; m.vy *= 0.72;
        m.x += m.vx; m.y += m.vy;
        if (Math.abs(m.x) + Math.abs(m.y) + Math.abs(m.vx) + Math.abs(m.vy) > 0.04) {
          busy = true;
          m.el.style.setProperty('--mx', m.x.toFixed(2) + 'px'); m.el.style.setProperty('--my', m.y.toFixed(2) + 'px');
          if (!m.hot) { m.hot = true; m.el.classList.add('is-mag'); }
        } else if (m.hot) {
          m.hot = false; m.x = m.y = m.vx = m.vy = 0;
          m.el.style.setProperty('--mx', '0px'); m.el.style.setProperty('--my', '0px'); m.el.classList.remove('is-mag');
        }
      }
      return busy;
    }
    function resetMags() { mags.forEach(function (m) { m.x = m.y = m.vx = m.vy = 0; m.hot = false; m.el.style.removeProperty('--mx'); m.el.style.removeProperty('--my'); m.el.classList.remove('is-mag'); }); }

    /* ---------- shared rAF loop: runs only while something is moving, stops by itself ---------- */
    var rafId = 0, running = false;
    function tick() {
      rafId = 0;
      if (!live()) { running = false; return; }
      var busy = false;
      try {
        if (C.ready) busy = stepCursor() || busy;
        if (mags.length) busy = stepMag() || busy;
      } catch (e) { warn(e); busy = false; }
      if (busy) rafId = requestAnimationFrame(tick); else running = false;
    }
    function kick() { if (!running && live() && (C.ready || mags.length)) { running = true; rafId = requestAnimationFrame(tick); } }
    function stopLoop() { if (rafId) cancelAnimationFrame(rafId); rafId = 0; running = false; }

    /* ---------- 7. Liquid-drop ripple: a soft disc plus a delayed thin ring, like a drop hitting perfume ---------- */
    var pressEl = null;
    function ripple(e) {
      if (reduce) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      var t = e.target && e.target.closest ? e.target.closest('.sa2-btn, .sa2-panel') : null;
      if (!t) return;
      var host = t.classList.contains('sa2-panel') ? (t.querySelector('.sa2-panel__in') || t) : t;
      var r = host.getBoundingClientRect(); /* one read per tap, never per frame */
      if (!r.width) return;
      var x = e.clientX - r.left, y = e.clientY - r.top, w = r.width, h = r.height;
      var far = Math.sqrt(Math.max(x, w - x) * Math.max(x, w - x) + Math.max(y, h - y) * Math.max(y, h - y));
      var wrap = mk('span', 'sa2-ripple' + (t.classList.contains('sa2-btn--dark') ? ' sa2-ripple--light' : ''));
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.setProperty('--x', x.toFixed(1) + 'px'); wrap.style.setProperty('--y', y.toFixed(1) + 'px');
      wrap.style.setProperty('--s', (far * 2).toFixed(0) + 'px');
      wrap.appendChild(mk('i', 'sa2-ripple__a')); wrap.appendChild(mk('i', 'sa2-ripple__b'));
      host.appendChild(wrap);
      setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 1000);
      release(); pressEl = host; host.classList.add('is-pressed');
    }
    function release() { if (pressEl) { pressEl.classList.remove('is-pressed'); pressEl = null; } }

    /* ---------- 8. Idle nudge: 6s without interaction while in view -> hint wiggles once ---------- */
    var hint = $('.sa2-hint'), idleT = null, nudges = 0, lastAct = 0;
    /* one timer that re-checks the last interaction time: pointermove fires ~100×/s, so no timer churn per event */
    function armIdle(ms) {
      if (idleT != null) return;
      if (!hint || reduce || nudges >= 3 || !live()) return;
      idleT = later(function () {
        idleT = null;
        if (!live()) return;
        var left = 6000 - (performance.now() - lastAct);
        if (left > 50) { armIdle(left); return; }
        if (hint.classList.contains('is-nudge')) return;
        nudges++;
        hint.classList.add('is-nudge');
        later(function () { hint.classList.remove('is-nudge'); }, 1400);
        lastAct = performance.now();
        armIdle(6000);
      }, ms || 6000);
    }
    function onAct() { lastAct = performance.now(); armIdle(6000); }

    /* ---------- lifecycle ---------- */
    function go() {
      if (!live()) return;
      setGreeting(); scheduleMorph(); lastAct = performance.now(); armIdle(6000); kick();
    }
    function halt() {
      clearTimers(); morphTimer = null; idleT = null;
      stopLoop(); stopScramble(); release();
      if (pending) finishSwap(false);
      if (cur && C.on) { C.on = false; cur.classList.remove('is-on'); }
      resetMags();
      if (hint) hint.classList.remove('is-nudge');
    }
    /* resize debounce lives outside the cancellable pool: halt() (tab hidden / off-screen) must not swallow a pending relayout */
    var resizeT = null;
    function onResize() {
      resizeT = null;
      if (!alive) return;
      DESK = !!(U.isDesk() && !U.isTouch);
      if (DESK) { setupCursor(); setupMag(); } else { resetMags(); mags = []; if (cur && C.on) { C.on = false; cur.classList.remove('is-on'); } }
      measureWords(); measureMags();
    }

    /* ---------- init (each part isolated so one failure never takes the rest down) ---------- */
    try { setGreeting(); } catch (e) { warn(e); }
    try { splitWords(); } catch (e) { warn(e); }
    try { setupMorph(); } catch (e) { warn(e); }
    try { setupCursor(); setupMag(); } catch (e) { warn(e); }
    /* ring emitted its first `front` before fx booted: seed the halo tint from shared state */
    try { if (cur && ST.tint) cur.style.setProperty('--sa2-fx-tint', String(ST.tint)); } catch (e) { warn(e); }
    try {
      listen(section, 'pointermove', function () { kick(); onAct(); }, { passive: true });
      listen(section, 'pointerenter', kick, { passive: true });
      listen(section, 'pointerdown', function (e) { try { ripple(e); } catch (x) { warn(x); } kick(); onAct(); }, { passive: true });
      listen(window, 'pointerup', release, { passive: true });
      listen(window, 'pointercancel', release, { passive: true });
      listen(section, 'keydown', onAct, { passive: true });
      listen(section, 'wheel', onAct, { passive: true });
      listen(section, 'touchstart', onAct, { passive: true });
      listen(section, 'pointerover', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('a, button, [role="button"]') : null; setLink(!!t);
      }, { passive: true });
      listen(section, 'pointerleave', function () { setLink(false); kick(); });
      listen(document, 'visibilitychange', function () { if (document.visibilityState === 'hidden') halt(); else go(); });
      listen(window, 'resize', function () { clearTimeout(resizeT); resizeT = setTimeout(function () { try { onResize(); } catch (e) { warn(e); } }, 160); }, { passive: true });
      offs.push(U.on('visible', function (e) {
        var v = !!(e.detail && e.detail.visible);
        if (v) { cascade(); go(); later(measureMags, 800); } else halt();
      }));
      offs.push(U.on('finder', function (e) {
        var open = !!(e.detail && e.detail.open);
        if (open) { halt(); setLink(false); } else { go(); later(measureMags, 500); }
      }));
      offs.push(U.on('front', function (e) {
        var d = (e && e.detail) || {};
        var el = (d.el && d.el.querySelector) ? d.el.querySelector('[data-sa2-scramble]') : $('.sa2-panel.is-front [data-sa2-scramble]');
        if (d.tint && cur) cur.style.setProperty('--sa2-fx-tint', String(d.tint));
        try { scramble(el); } catch (x) { warn(x); }
      }));
      if (!('IntersectionObserver' in window)) { cascade(); go(); }
    } catch (e) { warn(e); }

    return {
      pause: function () { paused = true; halt(); },
      resume: function () { paused = false; go(); },
      resize: function () { try { onResize(); } catch (e) { warn(e); } },
      destroy: function () {
        try {
          paused = true; halt(); alive = false;
          clearTimeout(resizeT); resizeT = null;
          offs.forEach(function (f) { try { f(); } catch (e) {} }); offs.length = 0;
          if (pre) pre.innerHTML = preOrig;
          if (morph) { morph.innerHTML = morphOrig; morph.style.removeProperty('width'); }
          if (greet && greetOn) greet.innerHTML = greetOrig;
          if (cur) { cur.textContent = ''; cur.className = cur.className.replace(/\bis-(ready|on|link|grab)\b/g, '').trim(); cur.style.removeProperty('--sa2-fx-tint'); }
          if (head) head.classList.remove('is-cascade');
          $$('.sa2-ripple').forEach(function (r) { if (r.parentNode) r.parentNode.removeChild(r); });
          $$('[data-sa2-text]').forEach(function (el) { el.textContent = el.getAttribute('data-sa2-text'); el.removeAttribute('data-sa2-text'); });
          mags = [];
        } catch (e) { warn(e); }
      }
    };
  });
})();

